var items = {
  "block.minecraft.acacia_button": "Akazienhoizknopf",
  "block.minecraft.acacia_door": "Akazienhoiztia",
  "block.minecraft.acacia_fence": "Akazienhoizzaun",
  "block.minecraft.acacia_fence_gate": "Akazienhoizzauntor",
  "block.minecraft.acacia_hanging_sign": "Akaziienhoizhängadsschuidl",
  "block.minecraft.acacia_leaves": "Akazienlaub",
  "block.minecraft.acacia_log": "Akazienstamm",
  "block.minecraft.acacia_planks": "Akazienhoizbretta",
  "block.minecraft.acacia_pressure_plate": "Akazienhoizdruckplatte",
  "block.minecraft.acacia_sapling": "Akazienzweigerl",
  "block.minecraft.acacia_shelf": "Akazienhoizreagl",
  "block.minecraft.acacia_sign": "Akazienhoizschuid",
  "block.minecraft.acacia_slab": "Akazienhoizstufe",
  "block.minecraft.acacia_stairs": "Akazienhoizschdiang",
  "block.minecraft.acacia_trapdoor": "Akazienhoizklappdierl",
  "block.minecraft.acacia_wall_hanging_sign": "Akazienhoizwandhängadsschuidl",
  "block.minecraft.acacia_wall_sign": "Akazienhoizmauaschuid",
  "block.minecraft.acacia_wood": "Akazienhoiz",
  "block.minecraft.activator_rail": "Aktivierungsschiene",
  "block.minecraft.air": "Luaft",
  "block.minecraft.allium": "Steanlauch",
  "block.minecraft.amethyst_block": "Amethystblock",
  "block.minecraft.amethyst_cluster": "Amethysthaufn",
  "block.minecraft.ancient_debris": "Antiker Schutt",
  "block.minecraft.andesite": "Andesit",
  "block.minecraft.andesite_slab": "Andesitstufe",
  "block.minecraft.andesite_stairs": "Andesitschdiang",
  "block.minecraft.andesite_wall": "Andesitmaua",
  "block.minecraft.anvil": "Amboss",
  "block.minecraft.attached_melon_stem": "Melonenranke",
  "block.minecraft.attached_pumpkin_stem": "Kürbisranke",
  "block.minecraft.azalea": "Azalee",
  "block.minecraft.azalea_leaves": "Azaleenlaub",
  "block.minecraft.azure_bluet": "Porzellansteanchn",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Bambusblock",
  "block.minecraft.bamboo_button": "Bambusknopf",
  "block.minecraft.bamboo_door": "Bambustür",
  "block.minecraft.bamboo_fence": "Bambuszaun",
  "block.minecraft.bamboo_fence_gate": "Bambuszauntor",
  "block.minecraft.bamboo_hanging_sign": "Bambushängadsschuidl",
  "block.minecraft.bamboo_mosaic": "Bambusmosaik",
  "block.minecraft.bamboo_mosaic_slab": "Bambusmosaikstufe",
  "block.minecraft.bamboo_mosaic_stairs": "Bambusmosaikschdiang",
  "block.minecraft.bamboo_planks": "Bambusbretta",
  "block.minecraft.bamboo_pressure_plate": "Bambusdruckplatte",
  "block.minecraft.bamboo_sapling": "Bambussprössling",
  "block.minecraft.bamboo_shelf": "Bambusreagl",
  "block.minecraft.bamboo_sign": "Bambusschuid",
  "block.minecraft.bamboo_slab": "Bambusstufe",
  "block.minecraft.bamboo_stairs": "Bambusschdiang",
  "block.minecraft.bamboo_trapdoor": "Bambusklappdierl",
  "block.minecraft.bamboo_wall_hanging_sign": "Bambuswandhängadsschuidl",
  "block.minecraft.bamboo_wall_sign": "Bambusmauaschuid",
  "block.minecraft.banner.base.black": "Voiständig schwoazs Feld",
  "block.minecraft.banner.base.blue": "Voiständig blaus Feld",
  "block.minecraft.banner.base.brown": "Voiständig brauns Feld",
  "block.minecraft.banner.base.cyan": "Voiständig türkis' Feld",
  "block.minecraft.banner.base.gray": "Voiständig graus Feld",
  "block.minecraft.banner.base.green": "Voiständig greans Feld",
  "block.minecraft.banner.base.light_blue": "Voiständig höiblaues Feld",
  "block.minecraft.banner.base.light_gray": "Voiständig höigraues Feld",
  "block.minecraft.banner.base.lime": "Voiständig giftgreans Feld",
  "block.minecraft.banner.base.magenta": "Voiständig magenta Feld",
  "block.minecraft.banner.base.orange": "Voiständig oranges Feld",
  "block.minecraft.banner.base.pink": "Voiständig rosa Feld",
  "block.minecraft.banner.base.purple": "Voiständig violetts Feld",
  "block.minecraft.banner.base.red": "Voiständig rouds Feld",
  "block.minecraft.banner.base.white": "Voiständig weißes Feld",
  "block.minecraft.banner.base.yellow": "Voiständig gejbs Feld",
  "block.minecraft.banner.border.black": "Schwoaza Bord",
  "block.minecraft.banner.border.blue": "Blaua Bord",
  "block.minecraft.banner.border.brown": "Brauna Bord",
  "block.minecraft.banner.border.cyan": "Türkisa Bord",
  "block.minecraft.banner.border.gray": "Graua Bord",
  "block.minecraft.banner.border.green": "Greana Bord",
  "block.minecraft.banner.border.light_blue": "Höiblaua Bord",
  "block.minecraft.banner.border.light_gray": "Höigraua Bord",
  "block.minecraft.banner.border.lime": "Giftgreana Bord",
  "block.minecraft.banner.border.magenta": "Magenta Bord",
  "block.minecraft.banner.border.orange": "Oranga Bord",
  "block.minecraft.banner.border.pink": "Rosa Bord",
  "block.minecraft.banner.border.purple": "Violetta Bord",
  "block.minecraft.banner.border.red": "Rouda Bord",
  "block.minecraft.banner.border.white": "Weißa Bord",
  "block.minecraft.banner.border.yellow": "Gejba Bord",
  "block.minecraft.banner.bricks.black": "Feld schwoaz g'mauat",
  "block.minecraft.banner.bricks.blue": "Feld blau g'mauat",
  "block.minecraft.banner.bricks.brown": "Feld braun g'mauat",
  "block.minecraft.banner.bricks.cyan": "Feld türkis g'mauat",
  "block.minecraft.banner.bricks.gray": "Feld grau g'mauat",
  "block.minecraft.banner.bricks.green": "Feld grean g'mauat",
  "block.minecraft.banner.bricks.light_blue": "Feld heiblau g'mauat",
  "block.minecraft.banner.bricks.light_gray": "Feld heigrau g'mauat",
  "block.minecraft.banner.bricks.lime": "Feld giftgrean g'mauat",
  "block.minecraft.banner.bricks.magenta": "Feld magenta g'mauat",
  "block.minecraft.banner.bricks.orange": "Feld orange g'mauat",
  "block.minecraft.banner.bricks.pink": "Feld rosa g'mauat",
  "block.minecraft.banner.bricks.purple": "Feld violett g'mauat",
  "block.minecraft.banner.bricks.red": "Feld roud g'mauat",
  "block.minecraft.banner.bricks.white": "Feld weiß g'mauat",
  "block.minecraft.banner.bricks.yellow": "Feld gejb g'mauat",
  "block.minecraft.banner.circle.black": "Schwoaze Kugl",
  "block.minecraft.banner.circle.blue": "Blaue Kugl",
  "block.minecraft.banner.circle.brown": "Braune Kugl",
  "block.minecraft.banner.circle.cyan": "Türkise Kugl",
  "block.minecraft.banner.circle.gray": "Graue Kugl",
  "block.minecraft.banner.circle.green": "Greane Kugl",
  "block.minecraft.banner.circle.light_blue": "Höiblaue Kugl",
  "block.minecraft.banner.circle.light_gray": "Höigraue Kugl",
  "block.minecraft.banner.circle.lime": "Giftgreane Kugl",
  "block.minecraft.banner.circle.magenta": "Magenta Kugl",
  "block.minecraft.banner.circle.orange": "Orange Kugl",
  "block.minecraft.banner.circle.pink": "Rosa Kugl",
  "block.minecraft.banner.circle.purple": "Violette Kugl",
  "block.minecraft.banner.circle.red": "Roude Kugl",
  "block.minecraft.banner.circle.white": "Weiße Kugl",
  "block.minecraft.banner.circle.yellow": "Gejb Kugl",
  "block.minecraft.banner.creeper.black": "Schwoaza Creeper",
  "block.minecraft.banner.creeper.blue": "Blaua Creeper",
  "block.minecraft.banner.creeper.brown": "Brauna Creeper",
  "block.minecraft.banner.creeper.cyan": "Türkisa Creeper",
  "block.minecraft.banner.creeper.gray": "Graua Creeper",
  "block.minecraft.banner.creeper.green": "Greana Creeper",
  "block.minecraft.banner.creeper.light_blue": "Höiblaua Creeper",
  "block.minecraft.banner.creeper.light_gray": "Höigraua Creeper",
  "block.minecraft.banner.creeper.lime": "Giftgreana Creeper",
  "block.minecraft.banner.creeper.magenta": "Magenta Creeper",
  "block.minecraft.banner.creeper.orange": "Oranga Creeper",
  "block.minecraft.banner.creeper.pink": "Rosa Creeper",
  "block.minecraft.banner.creeper.purple": "Violetta Creeper",
  "block.minecraft.banner.creeper.red": "Rouda Creeper",
  "block.minecraft.banner.creeper.white": "Weißa Creeper",
  "block.minecraft.banner.creeper.yellow": "Gejba Creeper",
  "block.minecraft.banner.cross.black": "Schwoazs Andreaskreiz",
  "block.minecraft.banner.cross.blue": "Blaus Andreaskreiz",
  "block.minecraft.banner.cross.brown": "Brauns Andreaskreiz",
  "block.minecraft.banner.cross.cyan": "Türkises Andreaskreiz",
  "block.minecraft.banner.cross.gray": "Graues Andreaskreiz",
  "block.minecraft.banner.cross.green": "Greans Andreaskreiz",
  "block.minecraft.banner.cross.light_blue": "Höiblaues Andreaskreiz",
  "block.minecraft.banner.cross.light_gray": "Höigraues Andreaskreiz",
  "block.minecraft.banner.cross.lime": "Giftgreans Andreaskreiz",
  "block.minecraft.banner.cross.magenta": "Magenta Andreaskreiz",
  "block.minecraft.banner.cross.orange": "Oranges Andreaskreiz",
  "block.minecraft.banner.cross.pink": "Rosa Andreaskreiz",
  "block.minecraft.banner.cross.purple": "Violetts Andreaskreiz",
  "block.minecraft.banner.cross.red": "Rouds Andreaskreiz",
  "block.minecraft.banner.cross.white": "Weißes Andreaskreiz",
  "block.minecraft.banner.cross.yellow": "Gejbs Andreaskreiz",
  "block.minecraft.banner.curly_border.black": "Schwoaza Spicklbord",
  "block.minecraft.banner.curly_border.blue": "Blaua Spicklbord",
  "block.minecraft.banner.curly_border.brown": "Brauna Spicklbord",
  "block.minecraft.banner.curly_border.cyan": "Türkisa Spicklbord",
  "block.minecraft.banner.curly_border.gray": "Graua Spicklbord",
  "block.minecraft.banner.curly_border.green": "Greana Spicklbord",
  "block.minecraft.banner.curly_border.light_blue": "Höiblaua Spicklbord",
  "block.minecraft.banner.curly_border.light_gray": "Höigraua Spicklbord",
  "block.minecraft.banner.curly_border.lime": "Giftgreana Spicklbord",
  "block.minecraft.banner.curly_border.magenta": "Magenta Spicklbord",
  "block.minecraft.banner.curly_border.orange": "Oranga Spicklbord",
  "block.minecraft.banner.curly_border.pink": "Rosa Spicklbord",
  "block.minecraft.banner.curly_border.purple": "Violetta Spicklbord",
  "block.minecraft.banner.curly_border.red": "Rouda Spicklbord",
  "block.minecraft.banner.curly_border.white": "Weißa Spicklbord",
  "block.minecraft.banner.curly_border.yellow": "Gejba Spicklbord",
  "block.minecraft.banner.diagonal_left.black": "Schwoaz schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.blue": "Blau schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.brown": "Braun schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.cyan": "Türkis schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.gray": "Grau schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.green": "Grean schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.light_blue": "Höiblau schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.light_gray": "Höigrau schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.lime": "Heigrean schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.orange": "Orange schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.pink": "Rosa schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.purple": "Violett schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.red": "Roud schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.white": "Weiß schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.yellow": "Gejb schräglinks geteilt",
  "block.minecraft.banner.diagonal_right.black": "Schwoaz schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.blue": "Blau schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.brown": "Braun schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.cyan": "Türkis schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.gray": "Grau schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.green": "Grean schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.light_blue": "Höiblau schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.light_gray": "Höigrau schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.lime": "Giftgrean schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.orange": "Orange schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.pink": "Rosa schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.purple": "Violett schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.red": "Roud schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.white": "Weiß schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.yellow": "Gejb schrägrechts geteilt",
  "block.minecraft.banner.diagonal_up_left.black": "Schwoaz schrägrechts geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.blue": "Blau schrägrechts geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.brown": "Braun schrägrechts geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.cyan": "Türkis schrägrechts geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.gray": "Grau schrägrechts geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.green": "Grean schrägrechts geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Höiblau schrägrechts geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Höigrau schrägrechts geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.lime": "Giftgrean schrägrechts geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta schrägrechts geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.orange": "Orange schrägrechts geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.pink": "Rosa schrägrechts geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.purple": "Violett schrägrechts geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.red": "Roud schrägrechts geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.white": "Weiß schrägrechts geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.yellow": "Gejb schrägrechts geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.black": "Schwoaz schräglinks geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.blue": "Blau schräglinks geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.brown": "Braun schräglinks geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.cyan": "Türkis schräglinks geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.gray": "Grau schräglinks geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.green": "Grean schräglinks geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Höiblau schräglinks geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Höigrau schräglinks geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.lime": "Heigrean schräglinks geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta schräglinks geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.orange": "Orange schräglinks geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.pink": "Rosa schräglinks geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.purple": "Violett schräglinks geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.red": "Roud schräglinks geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.white": "Weiß schräglinks geteilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.yellow": "Gejb schräglinks geteilt (Invertiert)",
  "block.minecraft.banner.flow.black": "Schwoaza Fluß",
  "block.minecraft.banner.flow.blue": "Blaua Fluß",
  "block.minecraft.banner.flow.brown": "Brauna Fluß",
  "block.minecraft.banner.flow.cyan": "Türkisa Fluß",
  "block.minecraft.banner.flow.gray": "Graua Fluß",
  "block.minecraft.banner.flow.green": "Greana Fluß",
  "block.minecraft.banner.flow.light_blue": "Höiblaua Fluß",
  "block.minecraft.banner.flow.light_gray": "Höigraua Fluß",
  "block.minecraft.banner.flow.lime": "Giftgreana Fluß",
  "block.minecraft.banner.flow.magenta": "Magenta Fluß",
  "block.minecraft.banner.flow.orange": "Oranga Fluß",
  "block.minecraft.banner.flow.pink": "Rosa Fluß",
  "block.minecraft.banner.flow.purple": "Violetta Fluß",
  "block.minecraft.banner.flow.red": "Rouda Fluß",
  "block.minecraft.banner.flow.white": "Weißa Fluß",
  "block.minecraft.banner.flow.yellow": "Gëiba Fluß",
  "block.minecraft.banner.flower.black": "Schwoaze Bleame",
  "block.minecraft.banner.flower.blue": "Blaue Bleame",
  "block.minecraft.banner.flower.brown": "Braune Bleame",
  "block.minecraft.banner.flower.cyan": "Türkise Bleame",
  "block.minecraft.banner.flower.gray": "Graue Bleame",
  "block.minecraft.banner.flower.green": "Greane Bleame",
  "block.minecraft.banner.flower.light_blue": "Höiblaue Bleame",
  "block.minecraft.banner.flower.light_gray": "Höigraue Bleame",
  "block.minecraft.banner.flower.lime": "Giftgreane Bleame",
  "block.minecraft.banner.flower.magenta": "Magenta Bleame",
  "block.minecraft.banner.flower.orange": "Orange Bleame",
  "block.minecraft.banner.flower.pink": "Rosa Bleame",
  "block.minecraft.banner.flower.purple": "Violette Bleame",
  "block.minecraft.banner.flower.red": "Roude Bleame",
  "block.minecraft.banner.flower.white": "Weiße Bleame",
  "block.minecraft.banner.flower.yellow": "Gejbe Bleame",
  "block.minecraft.banner.globe.black": "Schwoaza Globus",
  "block.minecraft.banner.globe.blue": "Blaua Globus",
  "block.minecraft.banner.globe.brown": "Brauna Globus",
  "block.minecraft.banner.globe.cyan": "Türkisa Globus",
  "block.minecraft.banner.globe.gray": "Graua Globus",
  "block.minecraft.banner.globe.green": "Greana Globus",
  "block.minecraft.banner.globe.light_blue": "Höiblaua Globus",
  "block.minecraft.banner.globe.light_gray": "Höigraua Globus",
  "block.minecraft.banner.globe.lime": "Giftgreana Globus",
  "block.minecraft.banner.globe.magenta": "Magenta Globus",
  "block.minecraft.banner.globe.orange": "Oranga Globus",
  "block.minecraft.banner.globe.pink": "Rosa Globus",
  "block.minecraft.banner.globe.purple": "Violetta Globus",
  "block.minecraft.banner.globe.red": "Rouda Globus",
  "block.minecraft.banner.globe.white": "Weißa Globus",
  "block.minecraft.banner.globe.yellow": "Gejba Globus",
  "block.minecraft.banner.gradient.black": "Schwoaza Foabverlaff",
  "block.minecraft.banner.gradient.blue": "Blaua Foabverlaff",
  "block.minecraft.banner.gradient.brown": "Brauna Foabverlaff",
  "block.minecraft.banner.gradient.cyan": "Türkisa Foabverlaff",
  "block.minecraft.banner.gradient.gray": "Graua Foabverlaff",
  "block.minecraft.banner.gradient.green": "Greana Foabverlaff",
  "block.minecraft.banner.gradient.light_blue": "Höiblaua Foabverlaff",
  "block.minecraft.banner.gradient.light_gray": "Höigraua Foabverlaff",
  "block.minecraft.banner.gradient.lime": "Giftgreana Foabverlaff",
  "block.minecraft.banner.gradient.magenta": "Magenta Foabverlaff",
  "block.minecraft.banner.gradient.orange": "Oranga Foabverlaff",
  "block.minecraft.banner.gradient.pink": "Rosa Foabverlaff",
  "block.minecraft.banner.gradient.purple": "Violetta Foabverlaff",
  "block.minecraft.banner.gradient.red": "Rouda Foabverlaff",
  "block.minecraft.banner.gradient.white": "Weißa Foabverlaff",
  "block.minecraft.banner.gradient.yellow": "Gejba Foabverlaff",
  "block.minecraft.banner.gradient_up.black": "Schwoaza Foabverlaff (Invertiert)",
  "block.minecraft.banner.gradient_up.blue": "Blaua Foabverlaff (Invertiert)",
  "block.minecraft.banner.gradient_up.brown": "Brauna Foabverlaff (Invertiert)",
  "block.minecraft.banner.gradient_up.cyan": "Türkisa Foabverlaff (Invertiert)",
  "block.minecraft.banner.gradient_up.gray": "Graua Foabverlaff (Invertiert)",
  "block.minecraft.banner.gradient_up.green": "Greana Foabverlaff (Invertiert)",
  "block.minecraft.banner.gradient_up.light_blue": "Höiblaua Foabverlaff (Invertiert)",
  "block.minecraft.banner.gradient_up.light_gray": "Höigraua Foabverlaff (Invertiert)",
  "block.minecraft.banner.gradient_up.lime": "Giftgreana Foabverlaff (Invertiert)",
  "block.minecraft.banner.gradient_up.magenta": "Magenta Foabverlaff (Invertiert)",
  "block.minecraft.banner.gradient_up.orange": "Oranga Foabverlaff (Invertiert)",
  "block.minecraft.banner.gradient_up.pink": "Rosa Foabverlaff (Invertiert)",
  "block.minecraft.banner.gradient_up.purple": "Violetta Foabverlaff (Invertiert)",
  "block.minecraft.banner.gradient_up.red": "Rouda Foabverlaff (Invertiert)",
  "block.minecraft.banner.gradient_up.white": "Weißa Foabverlaff (Invertiert)",
  "block.minecraft.banner.gradient_up.yellow": "Gejba Foabverlaff (Invertiert)",
  "block.minecraft.banner.guster.black": "Schwoaza Windstoußa",
  "block.minecraft.banner.guster.blue": "Blaua Windstoußa",
  "block.minecraft.banner.guster.brown": "Brauna Windstoußa",
  "block.minecraft.banner.guster.cyan": "Türkisa Windstoußa",
  "block.minecraft.banner.guster.gray": "Graua Windstoußa",
  "block.minecraft.banner.guster.green": "Greana Windstoußa",
  "block.minecraft.banner.guster.light_blue": "Höiblaua Windstoußa",
  "block.minecraft.banner.guster.light_gray": "Höigraua Windstoußa",
  "block.minecraft.banner.guster.lime": "Giftgreana Windstoußa",
  "block.minecraft.banner.guster.magenta": "Magneta Windstoußa",
  "block.minecraft.banner.guster.orange": "Oranga Windstoußa",
  "block.minecraft.banner.guster.pink": "Rosa Windstoußa",
  "block.minecraft.banner.guster.purple": "Violetta Windstoußa",
  "block.minecraft.banner.guster.red": "Rouda Windstoußa",
  "block.minecraft.banner.guster.white": "Weißa Windstoußa",
  "block.minecraft.banner.guster.yellow": "Gëiba Winstoußa",
  "block.minecraft.banner.half_horizontal.black": "Oben schwoaz g'teilt",
  "block.minecraft.banner.half_horizontal.blue": "Oben blau g'teilt",
  "block.minecraft.banner.half_horizontal.brown": "Oben braun g'teilt",
  "block.minecraft.banner.half_horizontal.cyan": "Oben türkis g'teilt",
  "block.minecraft.banner.half_horizontal.gray": "Oben grau g'teilt",
  "block.minecraft.banner.half_horizontal.green": "Oben grean g'teilt",
  "block.minecraft.banner.half_horizontal.light_blue": "Oben heiblau g'teilt",
  "block.minecraft.banner.half_horizontal.light_gray": "Oben heigrau g'teilt",
  "block.minecraft.banner.half_horizontal.lime": "Oben giftgrean g'teilt",
  "block.minecraft.banner.half_horizontal.magenta": "Oben magenta g'teilt",
  "block.minecraft.banner.half_horizontal.orange": "Oben orange g'teilt",
  "block.minecraft.banner.half_horizontal.pink": "Oben rosa g'teilt",
  "block.minecraft.banner.half_horizontal.purple": "Oben violett g'teilt",
  "block.minecraft.banner.half_horizontal.red": "Oben roud g'teilt",
  "block.minecraft.banner.half_horizontal.white": "Oben weiß g'teilt",
  "block.minecraft.banner.half_horizontal.yellow": "Oben gejb g'teilt",
  "block.minecraft.banner.half_horizontal_bottom.black": "Unten schwoaz g'teilt",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Unten blau g'teilt",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Unten braun g'teilt",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Unten türkis g'teilt",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Unten grau g'teilt",
  "block.minecraft.banner.half_horizontal_bottom.green": "Unten grean g'teilt",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Unten heiblau g'teilt",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Unten heigrau g'teilt",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Unten giftgrean g'teilt",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Unten magenta g'teilt",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Unten orange g'teilt",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Unten rosa g'teilt",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Unten violett g'teilt",
  "block.minecraft.banner.half_horizontal_bottom.red": "Unten roud g'teilt",
  "block.minecraft.banner.half_horizontal_bottom.white": "Unten weiß g'teilt",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Unten gejb g'teilt",
  "block.minecraft.banner.half_vertical.black": "Rechts schwoaz g'spaltn",
  "block.minecraft.banner.half_vertical.blue": "Rechts blau g'spaltn",
  "block.minecraft.banner.half_vertical.brown": "Rechts braun g'spaltn",
  "block.minecraft.banner.half_vertical.cyan": "Rechts türkis g'spaltn",
  "block.minecraft.banner.half_vertical.gray": "Rechts grau g'spaltn",
  "block.minecraft.banner.half_vertical.green": "Rechts grean g'spaltn",
  "block.minecraft.banner.half_vertical.light_blue": "Rechts heiblau g'spaltn",
  "block.minecraft.banner.half_vertical.light_gray": "Rechts heigrau g'spaltn",
  "block.minecraft.banner.half_vertical.lime": "Rechts giftgrean g'spaltn",
  "block.minecraft.banner.half_vertical.magenta": "Rechts magenta g'spaltn",
  "block.minecraft.banner.half_vertical.orange": "Rechts orange g'spaltn",
  "block.minecraft.banner.half_vertical.pink": "Rechts rosa g'spaltn",
  "block.minecraft.banner.half_vertical.purple": "Rechts violett g'spaltn",
  "block.minecraft.banner.half_vertical.red": "Rechts roud g'spaltn",
  "block.minecraft.banner.half_vertical.white": "Rechts weiß g'spaltn",
  "block.minecraft.banner.half_vertical.yellow": "Rechts gejb g'spaltn",
  "block.minecraft.banner.half_vertical_right.black": "Links schwoaz g'spaltn",
  "block.minecraft.banner.half_vertical_right.blue": "Links blau g'spaltn",
  "block.minecraft.banner.half_vertical_right.brown": "Links braun g'spaltn",
  "block.minecraft.banner.half_vertical_right.cyan": "Links türkis g'spaltn",
  "block.minecraft.banner.half_vertical_right.gray": "Links grau g'spaltn",
  "block.minecraft.banner.half_vertical_right.green": "Links grean g'spaltn",
  "block.minecraft.banner.half_vertical_right.light_blue": "Links heiblau g'spaltn",
  "block.minecraft.banner.half_vertical_right.light_gray": "Links heigrau g'spaltn",
  "block.minecraft.banner.half_vertical_right.lime": "Links giftgrean g'spaltn",
  "block.minecraft.banner.half_vertical_right.magenta": "Links magenta g'spaltn",
  "block.minecraft.banner.half_vertical_right.orange": "Links orange g'spaltn",
  "block.minecraft.banner.half_vertical_right.pink": "Links rosa g'spaltn",
  "block.minecraft.banner.half_vertical_right.purple": "Links violett g'spaltn",
  "block.minecraft.banner.half_vertical_right.red": "Links roud g'spaltn",
  "block.minecraft.banner.half_vertical_right.white": "Links weiß g'spaltn",
  "block.minecraft.banner.half_vertical_right.yellow": "Links gejb g'spaltn",
  "block.minecraft.banner.mojang.black": "Schwoazs Mojang-Logo",
  "block.minecraft.banner.mojang.blue": "Blaus Mojang-Logo",
  "block.minecraft.banner.mojang.brown": "Brauns Mojang-Logo",
  "block.minecraft.banner.mojang.cyan": "Türkis' Mojang-Logo",
  "block.minecraft.banner.mojang.gray": "Graus Mojang-Logo",
  "block.minecraft.banner.mojang.green": "Greans Mojang-Logo",
  "block.minecraft.banner.mojang.light_blue": "Höiblaues Mojang-Logo",
  "block.minecraft.banner.mojang.light_gray": "Höigraues Mojang-Logo",
  "block.minecraft.banner.mojang.lime": "Giftgreans Mojang-Logo",
  "block.minecraft.banner.mojang.magenta": "Magenta Mojang-Logo",
  "block.minecraft.banner.mojang.orange": "Oranges Mojang-Logo",
  "block.minecraft.banner.mojang.pink": "Rosa Mojang-Logo",
  "block.minecraft.banner.mojang.purple": "Violetts Mojang-Logo",
  "block.minecraft.banner.mojang.red": "Rouds Mojang-Logo",
  "block.minecraft.banner.mojang.white": "Weißes Mojang-Logo",
  "block.minecraft.banner.mojang.yellow": "Gejbs Mojang-Logo",
  "block.minecraft.banner.piglin.black": "Schwoaze Schnauze",
  "block.minecraft.banner.piglin.blue": "Blaue Schnauze",
  "block.minecraft.banner.piglin.brown": "Braune Schnauze",
  "block.minecraft.banner.piglin.cyan": "Türkise Schnauze",
  "block.minecraft.banner.piglin.gray": "Graue Schnauze",
  "block.minecraft.banner.piglin.green": "Greane Schnauze",
  "block.minecraft.banner.piglin.light_blue": "Höiblaue Schnauze",
  "block.minecraft.banner.piglin.light_gray": "Höigraue Schnauze",
  "block.minecraft.banner.piglin.lime": "Giftgreane Schnauze",
  "block.minecraft.banner.piglin.magenta": "Magenta Schnauze",
  "block.minecraft.banner.piglin.orange": "Orange Schnauze",
  "block.minecraft.banner.piglin.pink": "Rosa Schnauze",
  "block.minecraft.banner.piglin.purple": "Violette Schnauze",
  "block.minecraft.banner.piglin.red": "Roude Schnauze",
  "block.minecraft.banner.piglin.white": "Weiße Schnauze",
  "block.minecraft.banner.piglin.yellow": "Gejbe Schnauze",
  "block.minecraft.banner.rhombus.black": "Schwoaze Raute",
  "block.minecraft.banner.rhombus.blue": "Blaue Raute",
  "block.minecraft.banner.rhombus.brown": "Braune Raute",
  "block.minecraft.banner.rhombus.cyan": "Türkise Raute",
  "block.minecraft.banner.rhombus.gray": "Graue Raute",
  "block.minecraft.banner.rhombus.green": "Greane Raute",
  "block.minecraft.banner.rhombus.light_blue": "Höiblaue Raute",
  "block.minecraft.banner.rhombus.light_gray": "Höigraue Raute",
  "block.minecraft.banner.rhombus.lime": "Giftgreane Raute",
  "block.minecraft.banner.rhombus.magenta": "Magenta Raute",
  "block.minecraft.banner.rhombus.orange": "Orange Raute",
  "block.minecraft.banner.rhombus.pink": "Rosa Raute",
  "block.minecraft.banner.rhombus.purple": "Violette Raute",
  "block.minecraft.banner.rhombus.red": "Roude Raute",
  "block.minecraft.banner.rhombus.white": "Weiße Raute",
  "block.minecraft.banner.rhombus.yellow": "Gejbe Raute",
  "block.minecraft.banner.skull.black": "Schwoaza Schädl",
  "block.minecraft.banner.skull.blue": "Blaua Schädl",
  "block.minecraft.banner.skull.brown": "Brauna Schädl",
  "block.minecraft.banner.skull.cyan": "Türkisa Schädl",
  "block.minecraft.banner.skull.gray": "Graua Schädl",
  "block.minecraft.banner.skull.green": "Greana Schädl",
  "block.minecraft.banner.skull.light_blue": "Höiblaua Schädl",
  "block.minecraft.banner.skull.light_gray": "Höigraua Schädl",
  "block.minecraft.banner.skull.lime": "Giftgreana Schädl",
  "block.minecraft.banner.skull.magenta": "Magenta Schädl",
  "block.minecraft.banner.skull.orange": "Oranga Schädl",
  "block.minecraft.banner.skull.pink": "Rosa Schädl",
  "block.minecraft.banner.skull.purple": "Violetta Schädl",
  "block.minecraft.banner.skull.red": "Rouda Schädl",
  "block.minecraft.banner.skull.white": "Weißa Schädl",
  "block.minecraft.banner.skull.yellow": "Gejba Schädl",
  "block.minecraft.banner.small_stripes.black": "Via schwoaze Pfähle",
  "block.minecraft.banner.small_stripes.blue": "Via blaue Pfähle",
  "block.minecraft.banner.small_stripes.brown": "Via braune Pfähle",
  "block.minecraft.banner.small_stripes.cyan": "Via türkise Pfähle",
  "block.minecraft.banner.small_stripes.gray": "Via graue Pfähle",
  "block.minecraft.banner.small_stripes.green": "Via greane Pfähle",
  "block.minecraft.banner.small_stripes.light_blue": "Via heiblaue Pfähle",
  "block.minecraft.banner.small_stripes.light_gray": "Via heigraue Pfähle",
  "block.minecraft.banner.small_stripes.lime": "Via giftgreane Pfähle",
  "block.minecraft.banner.small_stripes.magenta": "Via magenta Pfähle",
  "block.minecraft.banner.small_stripes.orange": "Via orange Pfähle",
  "block.minecraft.banner.small_stripes.pink": "Via rosa Pfähle",
  "block.minecraft.banner.small_stripes.purple": "Via violette Pfähle",
  "block.minecraft.banner.small_stripes.red": "Via roude Pfähle",
  "block.minecraft.banner.small_stripes.white": "Via weiße Pfähle",
  "block.minecraft.banner.small_stripes.yellow": "Via gejbe Pfähle",
  "block.minecraft.banner.square_bottom_left.black": "Schwoazes Links' Untereck",
  "block.minecraft.banner.square_bottom_left.blue": "Blaues Links' Untereck",
  "block.minecraft.banner.square_bottom_left.brown": "Braunes Links' Untereck",
  "block.minecraft.banner.square_bottom_left.cyan": "Türkis' Links' Untereck",
  "block.minecraft.banner.square_bottom_left.gray": "Graues Links' Untereck",
  "block.minecraft.banner.square_bottom_left.green": "Greanes Links' Untereck",
  "block.minecraft.banner.square_bottom_left.light_blue": "Höiblaues rechtes Untaeck",
  "block.minecraft.banner.square_bottom_left.light_gray": "Höigraues Links' Untereck",
  "block.minecraft.banner.square_bottom_left.lime": "Giftgreanes Links' Untereck",
  "block.minecraft.banner.square_bottom_left.magenta": "Magenta rechtes Untaeck",
  "block.minecraft.banner.square_bottom_left.orange": "Oranges rechtes Untaeck",
  "block.minecraft.banner.square_bottom_left.pink": "Rosa Links' Untereck",
  "block.minecraft.banner.square_bottom_left.purple": "Lila Links' Untereck",
  "block.minecraft.banner.square_bottom_left.red": "Roudes Links' Untereck",
  "block.minecraft.banner.square_bottom_left.white": "Weißes rechtes Untaeck",
  "block.minecraft.banner.square_bottom_left.yellow": "Gejbs rechtes Untaeck",
  "block.minecraft.banner.square_bottom_right.black": "Schwoazs linkes Untaeck",
  "block.minecraft.banner.square_bottom_right.blue": "Blaus linkes Untaeck",
  "block.minecraft.banner.square_bottom_right.brown": "Brauns linkes Untaeck",
  "block.minecraft.banner.square_bottom_right.cyan": "Türkis' linkes Untaeck",
  "block.minecraft.banner.square_bottom_right.gray": "Graus linkes Untaeck",
  "block.minecraft.banner.square_bottom_right.green": "Greans linkes Untaeck",
  "block.minecraft.banner.square_bottom_right.light_blue": "Höiblaues linkes Untaeck",
  "block.minecraft.banner.square_bottom_right.light_gray": "Höigraues linkes Untaeck",
  "block.minecraft.banner.square_bottom_right.lime": "Giftgreans linkes Untaeck",
  "block.minecraft.banner.square_bottom_right.magenta": "Magenta linkes Untaeck",
  "block.minecraft.banner.square_bottom_right.orange": "Oranges linkes Untaeck",
  "block.minecraft.banner.square_bottom_right.pink": "Rosa linkes Untaeck",
  "block.minecraft.banner.square_bottom_right.purple": "Violetts linkes Untaeck",
  "block.minecraft.banner.square_bottom_right.red": "Rouds linkes Untaeck",
  "block.minecraft.banner.square_bottom_right.white": "Weißes linkes Untaeck",
  "block.minecraft.banner.square_bottom_right.yellow": "Gejbs linkes Untaeck",
  "block.minecraft.banner.square_top_left.black": "Schwoazs rechtes Obaeck",
  "block.minecraft.banner.square_top_left.blue": "Blaus rechtes Obaeck",
  "block.minecraft.banner.square_top_left.brown": "Brauns rechtes Obaeck",
  "block.minecraft.banner.square_top_left.cyan": "Türkis' rechtes Obaeck",
  "block.minecraft.banner.square_top_left.gray": "Graus rechtes Obaeck",
  "block.minecraft.banner.square_top_left.green": "Greans rechtes Obaeck",
  "block.minecraft.banner.square_top_left.light_blue": "Höiblaues rechtes Obaeck",
  "block.minecraft.banner.square_top_left.light_gray": "Höigraues rechtes Obaeck",
  "block.minecraft.banner.square_top_left.lime": "Giftgreans rechtes Obaeck",
  "block.minecraft.banner.square_top_left.magenta": "Magenta rechtes Obaeck",
  "block.minecraft.banner.square_top_left.orange": "Oranges rechtes Obaeck",
  "block.minecraft.banner.square_top_left.pink": "Rosa rechtes Obaeck",
  "block.minecraft.banner.square_top_left.purple": "Violetts rechtes Obaeck",
  "block.minecraft.banner.square_top_left.red": "Rouds rechtes Obaeck",
  "block.minecraft.banner.square_top_left.white": "Weißes rechtes Obaeck",
  "block.minecraft.banner.square_top_left.yellow": "Gejbs rechtes Obaeck",
  "block.minecraft.banner.square_top_right.black": "Schwoazs linkes Obaeck",
  "block.minecraft.banner.square_top_right.blue": "Blaus linkes Obaeck",
  "block.minecraft.banner.square_top_right.brown": "Brauns linkes Obaeck",
  "block.minecraft.banner.square_top_right.cyan": "Türkis' linkes Obaeck",
  "block.minecraft.banner.square_top_right.gray": "Graus linkes Obaeck",
  "block.minecraft.banner.square_top_right.green": "Greans linkes Obaeck",
  "block.minecraft.banner.square_top_right.light_blue": "Höiblaues linkes Obaeck",
  "block.minecraft.banner.square_top_right.light_gray": "Höigraues linkes Obaeck",
  "block.minecraft.banner.square_top_right.lime": "Höigraues linkes Obaeck",
  "block.minecraft.banner.square_top_right.magenta": "Magenta Links' Obereck",
  "block.minecraft.banner.square_top_right.orange": "Orangschenes Links' Obereck",
  "block.minecraft.banner.square_top_right.pink": "Rosa linkes Obaeck",
  "block.minecraft.banner.square_top_right.purple": "Violetts linkes Obaeck",
  "block.minecraft.banner.square_top_right.red": "Rouds linkes Obaeck",
  "block.minecraft.banner.square_top_right.white": "Weißes linkes' Obaeck",
  "block.minecraft.banner.square_top_right.yellow": "Gejbs linkes Obaeck",
  "block.minecraft.banner.straight_cross.black": "Schwoazs Kreiz",
  "block.minecraft.banner.straight_cross.blue": "Blaus Kreiz",
  "block.minecraft.banner.straight_cross.brown": "Brauns Kreiz",
  "block.minecraft.banner.straight_cross.cyan": "Türkis' Kreiz",
  "block.minecraft.banner.straight_cross.gray": "Graus Kreiz",
  "block.minecraft.banner.straight_cross.green": "Greans Kreiz",
  "block.minecraft.banner.straight_cross.light_blue": "Höiblaues Kreiz",
  "block.minecraft.banner.straight_cross.light_gray": "Höigraues Kreiz",
  "block.minecraft.banner.straight_cross.lime": "Giftgreans Kreiz",
  "block.minecraft.banner.straight_cross.magenta": "Magenta Kreiz",
  "block.minecraft.banner.straight_cross.orange": "Oranges Kreiz",
  "block.minecraft.banner.straight_cross.pink": "Rosa Kreiz",
  "block.minecraft.banner.straight_cross.purple": "Violetts Kreiz",
  "block.minecraft.banner.straight_cross.red": "Rouds Kreiz",
  "block.minecraft.banner.straight_cross.white": "Weißes Kreiz",
  "block.minecraft.banner.straight_cross.yellow": "Gejbs Kreiz",
  "block.minecraft.banner.stripe_bottom.black": "Schwoaza Bannerfuaß",
  "block.minecraft.banner.stripe_bottom.blue": "Blaua Bannerfuaß",
  "block.minecraft.banner.stripe_bottom.brown": "Brauna Bannerfuaß",
  "block.minecraft.banner.stripe_bottom.cyan": "Türkisa Bannerfuaß",
  "block.minecraft.banner.stripe_bottom.gray": "Graua Bannerfuaß",
  "block.minecraft.banner.stripe_bottom.green": "Greana Bannerfuaß",
  "block.minecraft.banner.stripe_bottom.light_blue": "Höiblaua Bannerfuaß",
  "block.minecraft.banner.stripe_bottom.light_gray": "Höigraua Bannerfuaß",
  "block.minecraft.banner.stripe_bottom.lime": "Giftgreana Bannerfuaß",
  "block.minecraft.banner.stripe_bottom.magenta": "Magenta Bannerfuaß",
  "block.minecraft.banner.stripe_bottom.orange": "Oranga Bannerfuaß",
  "block.minecraft.banner.stripe_bottom.pink": "Rosa Bannerfuaß",
  "block.minecraft.banner.stripe_bottom.purple": "Violetta Bannerfuaß",
  "block.minecraft.banner.stripe_bottom.red": "Rouda Bannerfuaß",
  "block.minecraft.banner.stripe_bottom.white": "Weissa Bannerfuaß",
  "block.minecraft.banner.stripe_bottom.yellow": "Gelba Bannerfuaß",
  "block.minecraft.banner.stripe_center.black": "Schwoaza Pfahl",
  "block.minecraft.banner.stripe_center.blue": "Blaua Pfahl",
  "block.minecraft.banner.stripe_center.brown": "Brauna Pfahl",
  "block.minecraft.banner.stripe_center.cyan": "Türkisa Pfahl",
  "block.minecraft.banner.stripe_center.gray": "Graua Pfahl",
  "block.minecraft.banner.stripe_center.green": "Greana Pfahl",
  "block.minecraft.banner.stripe_center.light_blue": "Höiblaua Pfahl",
  "block.minecraft.banner.stripe_center.light_gray": "Höigraua Pfahl",
  "block.minecraft.banner.stripe_center.lime": "Giftgreana Pfahl",
  "block.minecraft.banner.stripe_center.magenta": "Magenta Pfahl",
  "block.minecraft.banner.stripe_center.orange": "Oranga Pfahl",
  "block.minecraft.banner.stripe_center.pink": "Rosa Pfahl",
  "block.minecraft.banner.stripe_center.purple": "Violetta Pfahl",
  "block.minecraft.banner.stripe_center.red": "Rouda Pfahl",
  "block.minecraft.banner.stripe_center.white": "Weißa Pfahl",
  "block.minecraft.banner.stripe_center.yellow": "Gejba Pfahl",
  "block.minecraft.banner.stripe_downleft.black": "Schwoaza Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.blue": "Blaua Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.brown": "Brauna Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.cyan": "Türkisa Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.gray": "Graua Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.green": "Greana Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.light_blue": "Höiblaua Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.light_gray": "Höigraua Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.lime": "Giftgreana Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.orange": "Orangschener Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.pink": "Rosa Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.purple": "Violetta Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.red": "Rouda Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.white": "Weissa Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.yellow": "Gelba Schräglinksboikn",
  "block.minecraft.banner.stripe_downright.black": "Schwoaza Schrägboikn",
  "block.minecraft.banner.stripe_downright.blue": "Blaua Schrägboikn",
  "block.minecraft.banner.stripe_downright.brown": "Brauna Schrägboikn",
  "block.minecraft.banner.stripe_downright.cyan": "Türkisa Schrägboikn",
  "block.minecraft.banner.stripe_downright.gray": "Graua Schrägboikn",
  "block.minecraft.banner.stripe_downright.green": "Greana Schrägboikn",
  "block.minecraft.banner.stripe_downright.light_blue": "Höiblaua Schrägboikn",
  "block.minecraft.banner.stripe_downright.light_gray": "Höigraua Schrägboikn",
  "block.minecraft.banner.stripe_downright.lime": "Giftgreana Schrägboikn",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta Schrägboikn",
  "block.minecraft.banner.stripe_downright.orange": "Orangschener Schrägboikn",
  "block.minecraft.banner.stripe_downright.pink": "Rosa Schrägboikn",
  "block.minecraft.banner.stripe_downright.purple": "Lila Schrägboikn",
  "block.minecraft.banner.stripe_downright.red": "Rouda Schrägboikn",
  "block.minecraft.banner.stripe_downright.white": "Weissa Schrägboikn",
  "block.minecraft.banner.stripe_downright.yellow": "Gelba Schrägboikn",
  "block.minecraft.banner.stripe_left.black": "Schwoaze rechte Flanke",
  "block.minecraft.banner.stripe_left.blue": "Blaue rechte Flanke",
  "block.minecraft.banner.stripe_left.brown": "Braune rechte Flanke",
  "block.minecraft.banner.stripe_left.cyan": "Türkise rechte Flanke",
  "block.minecraft.banner.stripe_left.gray": "Graue rechte Flanke",
  "block.minecraft.banner.stripe_left.green": "Greane rechte Flanke",
  "block.minecraft.banner.stripe_left.light_blue": "Höiblaue rechte Flanke",
  "block.minecraft.banner.stripe_left.light_gray": "Höigraue rechte Flanke",
  "block.minecraft.banner.stripe_left.lime": "Giftgreane rechte Flanke",
  "block.minecraft.banner.stripe_left.magenta": "Magenta rechte Flanke",
  "block.minecraft.banner.stripe_left.orange": "Orange rechte Flanke",
  "block.minecraft.banner.stripe_left.pink": "Rosa rechte Flanke",
  "block.minecraft.banner.stripe_left.purple": "Violette rechte Flanke",
  "block.minecraft.banner.stripe_left.red": "Roude rechte Flanke",
  "block.minecraft.banner.stripe_left.white": "Weiße rechte Flanke",
  "block.minecraft.banner.stripe_left.yellow": "Gejbe rechte Flanke",
  "block.minecraft.banner.stripe_middle.black": "Schwoaza Boikn",
  "block.minecraft.banner.stripe_middle.blue": "Blaua Boikn",
  "block.minecraft.banner.stripe_middle.brown": "Brauna Boikn",
  "block.minecraft.banner.stripe_middle.cyan": "Türkisa Boikn",
  "block.minecraft.banner.stripe_middle.gray": "Graua Boikn",
  "block.minecraft.banner.stripe_middle.green": "Greana Boikn",
  "block.minecraft.banner.stripe_middle.light_blue": "Höiblaua Boikn",
  "block.minecraft.banner.stripe_middle.light_gray": "Höigraua Boikn",
  "block.minecraft.banner.stripe_middle.lime": "Giftgreana Boikn",
  "block.minecraft.banner.stripe_middle.magenta": "Magenta Boikn",
  "block.minecraft.banner.stripe_middle.orange": "Oranga Boikn",
  "block.minecraft.banner.stripe_middle.pink": "Rosa Boikn",
  "block.minecraft.banner.stripe_middle.purple": "Violetta Boikn",
  "block.minecraft.banner.stripe_middle.red": "Rouda Boikn",
  "block.minecraft.banner.stripe_middle.white": "Weißa Boikn",
  "block.minecraft.banner.stripe_middle.yellow": "Gejba Boikn",
  "block.minecraft.banner.stripe_right.black": "Schwoaze linke Flanke",
  "block.minecraft.banner.stripe_right.blue": "Blaue linke Flanke",
  "block.minecraft.banner.stripe_right.brown": "Braune linke Flanke",
  "block.minecraft.banner.stripe_right.cyan": "Türkise linke Flanke",
  "block.minecraft.banner.stripe_right.gray": "Graue linke Flanke",
  "block.minecraft.banner.stripe_right.green": "Greane linke Flanke",
  "block.minecraft.banner.stripe_right.light_blue": "Höiblaue linke Flanke",
  "block.minecraft.banner.stripe_right.light_gray": "Höigraue linke Flanke",
  "block.minecraft.banner.stripe_right.lime": "Griftgreane linke Flanke",
  "block.minecraft.banner.stripe_right.magenta": "Magenta linke Flanke",
  "block.minecraft.banner.stripe_right.orange": "Orange linke Flanke",
  "block.minecraft.banner.stripe_right.pink": "Rosa linke Flanke",
  "block.minecraft.banner.stripe_right.purple": "Violette linke Flanke",
  "block.minecraft.banner.stripe_right.red": "Roude linke Flanke",
  "block.minecraft.banner.stripe_right.white": "Weiße linke Flanke",
  "block.minecraft.banner.stripe_right.yellow": "Gejbe linke Flanke",
  "block.minecraft.banner.stripe_top.black": "Schwoazs Bannerhaupt",
  "block.minecraft.banner.stripe_top.blue": "Blaus Bannerhaupt",
  "block.minecraft.banner.stripe_top.brown": "Brauns Bannerhaupt",
  "block.minecraft.banner.stripe_top.cyan": "Türkis' Bannerhaupt",
  "block.minecraft.banner.stripe_top.gray": "Graus Bannerhaupt",
  "block.minecraft.banner.stripe_top.green": "Greans Bannerhaupt",
  "block.minecraft.banner.stripe_top.light_blue": "Höiblaues Bannerhaupt",
  "block.minecraft.banner.stripe_top.light_gray": "Höigraues Bannerhaupt",
  "block.minecraft.banner.stripe_top.lime": "Giftgreans Bannerhaupt",
  "block.minecraft.banner.stripe_top.magenta": "Magenta Bannerhaupt",
  "block.minecraft.banner.stripe_top.orange": "Oranges Bannerhaupt",
  "block.minecraft.banner.stripe_top.pink": "Rosa Bannerhaupt",
  "block.minecraft.banner.stripe_top.purple": "Violetts Bannerhaupt",
  "block.minecraft.banner.stripe_top.red": "Rouds Bannerhaupt",
  "block.minecraft.banner.stripe_top.white": "Weißes Bannerhaupt",
  "block.minecraft.banner.stripe_top.yellow": "Gejbs Bannerhaupt",
  "block.minecraft.banner.triangle_bottom.black": "Schwoaze hoibe Spitze",
  "block.minecraft.banner.triangle_bottom.blue": "Blaue hoibe Spitze",
  "block.minecraft.banner.triangle_bottom.brown": "Braune hoibe Spitze",
  "block.minecraft.banner.triangle_bottom.cyan": "Türkise hoibe Spitze",
  "block.minecraft.banner.triangle_bottom.gray": "Graue hoibe Spitze",
  "block.minecraft.banner.triangle_bottom.green": "Greane hoibe Spitze",
  "block.minecraft.banner.triangle_bottom.light_blue": "Höiblaue hoibe Spitze",
  "block.minecraft.banner.triangle_bottom.light_gray": "Höigraue hoibe Spitze",
  "block.minecraft.banner.triangle_bottom.lime": "Giftgreane hoibe Spitze",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenta hoibe Spitze",
  "block.minecraft.banner.triangle_bottom.orange": "Orange hoibe Spitze",
  "block.minecraft.banner.triangle_bottom.pink": "Rosa hoibe Spitze",
  "block.minecraft.banner.triangle_bottom.purple": "Violette hoibe Spitze",
  "block.minecraft.banner.triangle_bottom.red": "Roude hoibe Spitze",
  "block.minecraft.banner.triangle_bottom.white": "Weiße hoibe Spitze",
  "block.minecraft.banner.triangle_bottom.yellow": "Gejbe hoibe Spitze",
  "block.minecraft.banner.triangle_top.black": "Schwoaze gestürzte hoibe Spitze",
  "block.minecraft.banner.triangle_top.blue": "Blaue gestürzte hoibe Spitze",
  "block.minecraft.banner.triangle_top.brown": "Braune gestürzte hoibe Spitze",
  "block.minecraft.banner.triangle_top.cyan": "Türkise gestürzte hoibe Spitze",
  "block.minecraft.banner.triangle_top.gray": "Graue gestürzte hoibe Spitze",
  "block.minecraft.banner.triangle_top.green": "Greane gestürzte hoibe Spitze",
  "block.minecraft.banner.triangle_top.light_blue": "Höiblaue gestürzte hoibe Spitze",
  "block.minecraft.banner.triangle_top.light_gray": "Höigraue gestürzte hoibe Spitze",
  "block.minecraft.banner.triangle_top.lime": "Giftgreane gestürzte hoibe Spitze",
  "block.minecraft.banner.triangle_top.magenta": "Magenta gestürzte hoibe Spitze",
  "block.minecraft.banner.triangle_top.orange": "Orange gestürzte hoibe Spitze",
  "block.minecraft.banner.triangle_top.pink": "Rosa gestürzte hoibe Spitze",
  "block.minecraft.banner.triangle_top.purple": "Violette gestürzte hoibe Spitze",
  "block.minecraft.banner.triangle_top.red": "Roude gestürzte hoibe Spitze",
  "block.minecraft.banner.triangle_top.white": "Weiße gestürzte hoibe Spitze",
  "block.minecraft.banner.triangle_top.yellow": "Gejbe gestürzte hoibe Spitze",
  "block.minecraft.banner.triangles_bottom.black": "Schwoaza gspickelta Bannerfuaß",
  "block.minecraft.banner.triangles_bottom.blue": "Blaua gspickelta Bannerfuaß",
  "block.minecraft.banner.triangles_bottom.brown": "Brauna gspickelta Bannerfuaß",
  "block.minecraft.banner.triangles_bottom.cyan": "Türkisa gspickelta Bannerfuaß",
  "block.minecraft.banner.triangles_bottom.gray": "Graua gspickelta Bannerfuaß",
  "block.minecraft.banner.triangles_bottom.green": "Greana gspickelta Bannerfuaß",
  "block.minecraft.banner.triangles_bottom.light_blue": "Höiblaua gspickelta Bannerfuaß",
  "block.minecraft.banner.triangles_bottom.light_gray": "Höigraua gspickelta Bannerfuaß",
  "block.minecraft.banner.triangles_bottom.lime": "Giftgreana gspickelta Bannerfuaß",
  "block.minecraft.banner.triangles_bottom.magenta": "Magenta gspickelta Bannerfuaß",
  "block.minecraft.banner.triangles_bottom.orange": "Oranga gspickelta Bannerfuaß",
  "block.minecraft.banner.triangles_bottom.pink": "Rosa gspickelta Bannerfuaß",
  "block.minecraft.banner.triangles_bottom.purple": "Violetta gspickelta Bannerfuaß",
  "block.minecraft.banner.triangles_bottom.red": "Rouda gspickelta Bannerfuaß",
  "block.minecraft.banner.triangles_bottom.white": "Weißa gspickelta Bannerfuaß",
  "block.minecraft.banner.triangles_bottom.yellow": "Gejba gspickelta Bannerfuaß",
  "block.minecraft.banner.triangles_top.black": "Schwoazs gspickelta Bannerhaupt",
  "block.minecraft.banner.triangles_top.blue": "Blaus gspickelta Bannerhaupt",
  "block.minecraft.banner.triangles_top.brown": "Brauns gspickelta Bannerhaupt",
  "block.minecraft.banner.triangles_top.cyan": "Türkis' gspickelta Bannerhaupt",
  "block.minecraft.banner.triangles_top.gray": "Graus gspickelta Bannerhaupt",
  "block.minecraft.banner.triangles_top.green": "Greans gspickelta Bannerhaupt",
  "block.minecraft.banner.triangles_top.light_blue": "Höiblaues gspickelta Bannerhaupt",
  "block.minecraft.banner.triangles_top.light_gray": "Höigraues gspickelta Bannerhaupt",
  "block.minecraft.banner.triangles_top.lime": "Giftgreans gspickelta Bannerhaupt",
  "block.minecraft.banner.triangles_top.magenta": "Magenta gspickelta Bannerhaupt",
  "block.minecraft.banner.triangles_top.orange": "Oranges gspickelta Bannerhaupt",
  "block.minecraft.banner.triangles_top.pink": "Rosa gspickelta Bannerhaupt",
  "block.minecraft.banner.triangles_top.purple": "Violetts gspickelta Bannerhaupt",
  "block.minecraft.banner.triangles_top.red": "Rouds gspickelta Bannerhaupt",
  "block.minecraft.banner.triangles_top.white": "Weißes gspickelta Bannerhaupt",
  "block.minecraft.banner.triangles_top.yellow": "Gejbs gspickelta Bannerhaupt",
  "block.minecraft.barrel": "Fassl",
  "block.minecraft.barrier": "Barriere",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Leichtfeia",
  "block.minecraft.beacon.primary": "Primäre Kroft",
  "block.minecraft.beacon.secondary": "Sekundäre Kroft",
  "block.minecraft.bed.no_sleep": "Du konnst nua nochts und während Gewitter schlafen",
  "block.minecraft.bed.not_safe": "Du konnst jetzt ned schlafen, es san Ungeheia in da Nähe",
  "block.minecraft.bed.obstructed": "Dieses Bett is blockiat",
  "block.minecraft.bed.occupied": "Dieses Bett is belegt",
  "block.minecraft.bed.too_far_away": "Du konnst ned schlofa, des Bed is z’weit weg",
  "block.minecraft.bedrock": "Grundstoa",
  "block.minecraft.bee_nest": "Impnnest",
  "block.minecraft.beehive": "Impnstock",
  "block.minecraft.beetroots": "Ranna",
  "block.minecraft.bell": "Glocke",
  "block.minecraft.big_dripleaf": "Groußes Dropfbladl",
  "block.minecraft.big_dripleaf_stem": "Groußa Dropfbladlstil",
  "block.minecraft.birch_button": "Birknhoizknopf",
  "block.minecraft.birch_door": "Birknhoiztia",
  "block.minecraft.birch_fence": "Birknhoizzaun",
  "block.minecraft.birch_fence_gate": "Birknhoizzauntor",
  "block.minecraft.birch_hanging_sign": "Birknhoizhängadsschuidl",
  "block.minecraft.birch_leaves": "Birknlaub",
  "block.minecraft.birch_log": "Birkenhoiz",
  "block.minecraft.birch_planks": "Birknhoizbretta",
  "block.minecraft.birch_pressure_plate": "Birknhoizdruckplatte",
  "block.minecraft.birch_sapling": "Birknzweigerl",
  "block.minecraft.birch_shelf": "Birknhoizreagl",
  "block.minecraft.birch_sign": "Birknhoizschuid",
  "block.minecraft.birch_slab": "Birknhoizstufe",
  "block.minecraft.birch_stairs": "Birkenhoizschdiang",
  "block.minecraft.birch_trapdoor": "Birknhoizklappdierl",
  "block.minecraft.birch_wall_hanging_sign": "Birknhoizwandhängadsschuidl",
  "block.minecraft.birch_wall_sign": "Birknhoizmauaschuid",
  "block.minecraft.birch_wood": "Birknhoiz",
  "block.minecraft.black_banner": "Schwoaza Banner",
  "block.minecraft.black_bed": "Schwoazs Bett",
  "block.minecraft.black_candle": "Schwoaze Keaze",
  "block.minecraft.black_candle_cake": "Kuachn mid schwoaza Keaze",
  "block.minecraft.black_carpet": "Schwoaza Teppich",
  "block.minecraft.black_concrete": "Schwoaza Bedau",
  "block.minecraft.black_concrete_powder": "Schwoaza Trocknbedau",
  "block.minecraft.black_glazed_terracotta": "Schwoaze glasierte Keramik",
  "block.minecraft.black_shulker_box": "Schwoaze Shulker-Kiste",
  "block.minecraft.black_stained_glass": "Schwoazs Glas",
  "block.minecraft.black_stained_glass_pane": "Schwoaze Glasscheibe",
  "block.minecraft.black_terracotta": "Schwoazs Keramik",
  "block.minecraft.black_wool": "Schwoaze Wolle",
  "block.minecraft.blackstone": "Schwoazstoa",
  "block.minecraft.blackstone_slab": "Schwoazstoastufe",
  "block.minecraft.blackstone_stairs": "Schwoazstoaschdiang",
  "block.minecraft.blackstone_wall": "Schwoazstoamaua",
  "block.minecraft.blast_furnace": "Schmöizofn",
  "block.minecraft.blue_banner": "Blaua Banner",
  "block.minecraft.blue_bed": "Blaus Bett",
  "block.minecraft.blue_candle": "Blaue Keaze",
  "block.minecraft.blue_candle_cake": "Kuachn mid blaua Keaze",
  "block.minecraft.blue_carpet": "Blaua Teppich",
  "block.minecraft.blue_concrete": "Blaua Bedau",
  "block.minecraft.blue_concrete_powder": "Blaua Trocknbedau",
  "block.minecraft.blue_glazed_terracotta": "Blaue glasierte Keramik",
  "block.minecraft.blue_ice": "Blaueis",
  "block.minecraft.blue_orchid": "Blaue Oachidee",
  "block.minecraft.blue_shulker_box": "Blaue Shulker-Kiste",
  "block.minecraft.blue_stained_glass": "Blaus Glas",
  "block.minecraft.blue_stained_glass_pane": "Blaue Glasscheibe",
  "block.minecraft.blue_terracotta": "Blaus Keramik",
  "block.minecraft.blue_wool": "Blaue Wolle",
  "block.minecraft.bone_block": "Boanenblock",
  "block.minecraft.bookshelf": "Buacharegal",
  "block.minecraft.brain_coral": "Hirnkoralle",
  "block.minecraft.brain_coral_block": "Hirnkorallnblock",
  "block.minecraft.brain_coral_fan": "Hirnkorallnfächer",
  "block.minecraft.brain_coral_wall_fan": "Hirnkorallnwandfächa",
  "block.minecraft.brewing_stand": "Braustand",
  "block.minecraft.brick_slab": "Ziegelstufe",
  "block.minecraft.brick_stairs": "Zieglschdiang",
  "block.minecraft.brick_wall": "Zieglstoimaua",
  "block.minecraft.bricks": "Zieglstoane",
  "block.minecraft.brown_banner": "Brauna Banner",
  "block.minecraft.brown_bed": "Brauns Bett",
  "block.minecraft.brown_candle": "Braune Keaze",
  "block.minecraft.brown_candle_cake": "Kuachn mid brauna Keaze",
  "block.minecraft.brown_carpet": "Brauna Teppich",
  "block.minecraft.brown_concrete": "Brauna Bedau",
  "block.minecraft.brown_concrete_powder": "Brauna Trocknbedau",
  "block.minecraft.brown_glazed_terracotta": "Braune glasierte Keramik",
  "block.minecraft.brown_mushroom": "Brauna Schwammal",
  "block.minecraft.brown_mushroom_block": "Brauna Schwammalblock",
  "block.minecraft.brown_shulker_box": "Braune Shulker-Kiste",
  "block.minecraft.brown_stained_glass": "Brauns Glas",
  "block.minecraft.brown_stained_glass_pane": "Braune Glasscheibe",
  "block.minecraft.brown_terracotta": "Brauns Keramik",
  "block.minecraft.brown_wool": "Braune Wolle",
  "block.minecraft.bubble_column": "Blasnsäule",
  "block.minecraft.bubble_coral": "Blasnkoralle",
  "block.minecraft.bubble_coral_block": "Blasenkorallnblock",
  "block.minecraft.bubble_coral_fan": "Blasenkorallnfächer",
  "block.minecraft.bubble_coral_wall_fan": "Blosnkorallnwandfächa",
  "block.minecraft.budding_amethyst": "Amethystknospnblock",
  "block.minecraft.bush": "Busch",
  "block.minecraft.cactus": "Kaktää",
  "block.minecraft.cactus_flower": "Kaktusblüte",
  "block.minecraft.cake": "Kuacha",
  "block.minecraft.calcite": "Koichstoa",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrierta Sculk-Sensor",
  "block.minecraft.campfire": "Lagafeia",
  "block.minecraft.candle": "Keaze",
  "block.minecraft.candle_cake": "Kuachn mid Keaze",
  "block.minecraft.carrots": "Gejbe Ruamen",
  "block.minecraft.cartography_table": "Koatndisch",
  "block.minecraft.carved_pumpkin": "G'schnitzta Kürbis",
  "block.minecraft.cauldron": "Kessl",
  "block.minecraft.cave_air": "Höinlufd",
  "block.minecraft.cave_vines": "Höinrankn",
  "block.minecraft.cave_vines_plant": "Höinranknpflanzna",
  "block.minecraft.chain": "Verkettn",
  "block.minecraft.chain_command_block": "Kettn-Befehlsblock",
  "block.minecraft.cherry_button": "Kiaschhoizknopf",
  "block.minecraft.cherry_door": "Kiaschhoiztia",
  "block.minecraft.cherry_fence": "Kiaschhoizzaun",
  "block.minecraft.cherry_fence_gate": "Kiaschhoizzauntor",
  "block.minecraft.cherry_hanging_sign": "Kiaschhoiz",
  "block.minecraft.cherry_leaves": "Kiaschlaub",
  "block.minecraft.cherry_log": "Kiaschstamm",
  "block.minecraft.cherry_planks": "Kiaschhoizbretta",
  "block.minecraft.cherry_pressure_plate": "Kiaschhoizdruckplatte",
  "block.minecraft.cherry_sapling": "Kiaschzweigerl",
  "block.minecraft.cherry_shelf": "Kirschhoizreagl",
  "block.minecraft.cherry_sign": "Kiaschhoizschuid",
  "block.minecraft.cherry_slab": "Kiaschhoizstufe",
  "block.minecraft.cherry_stairs": "Kiaschhoizschdiang",
  "block.minecraft.cherry_trapdoor": "Kiaschhoizklappdierl",
  "block.minecraft.cherry_wall_hanging_sign": "Kirschhoizwandhängadsschuidl",
  "block.minecraft.cherry_wall_sign": "Kiaschhoizmauaschuid",
  "block.minecraft.cherry_wood": "Kiaschhoiz",
  "block.minecraft.chest": "Truhe",
  "block.minecraft.chipped_anvil": "Oang'schlog'na Amboss",
  "block.minecraft.chiseled_bookshelf": "G'oabads Bücharegal",
  "block.minecraft.chiseled_copper": "Gmeißelta Kupfablock",
  "block.minecraft.chiseled_deepslate": "Gemeißelta Diafnschiefa",
  "block.minecraft.chiseled_nether_bricks": "Gemeißelte Netherziegl",
  "block.minecraft.chiseled_polished_blackstone": "Gemeißelta polierta Schwoazstoa",
  "block.minecraft.chiseled_quartz_block": "Gemeißelta Quarzblock",
  "block.minecraft.chiseled_red_sandstone": "Gemeißelta rouder Sondstoa",
  "block.minecraft.chiseled_resin_bricks": "Gmeißelte Harzziegel",
  "block.minecraft.chiseled_sandstone": "Gemeißelta Sondstoa",
  "block.minecraft.chiseled_stone_bricks": "G’meißlte Stoazigl",
  "block.minecraft.chiseled_tuff": "Gmeißelta Tuffstoa",
  "block.minecraft.chiseled_tuff_bricks": "Gmeißelte Tuffziagl",
  "block.minecraft.chorus_flower": "Chorusbliate",
  "block.minecraft.chorus_plant": "Choruspflanzna",
  "block.minecraft.clay": "Ton",
  "block.minecraft.closed_eyeblossom": "Gschlossane Augnbliatn",
  "block.minecraft.coal_block": "Kuinblock",
  "block.minecraft.coal_ore": "Kuinerz",
  "block.minecraft.coarse_dirt": "Gorbe Eadn",
  "block.minecraft.cobbled_deepslate": "Bruchtiefnschiefa",
  "block.minecraft.cobbled_deepslate_slab": "Bruchtiefnschiefastufe",
  "block.minecraft.cobbled_deepslate_stairs": "Bruchtiefnschiefaschdiang",
  "block.minecraft.cobbled_deepslate_wall": "Bruchtiefnschiefamaua",
  "block.minecraft.cobblestone": "Bruchstoa",
  "block.minecraft.cobblestone_slab": "Bruchstoastufe",
  "block.minecraft.cobblestone_stairs": "Bruchstoaschdiang",
  "block.minecraft.cobblestone_wall": "Bruchstoamaua",
  "block.minecraft.cobweb": "Spinnfeggeln",
  "block.minecraft.cocoa": "Gaugau",
  "block.minecraft.command_block": "Befehlsblock",
  "block.minecraft.comparator": "Redstone Komparatoa",
  "block.minecraft.composter": "Kompostiaanlag",
  "block.minecraft.conduit": "Aquisator",
  "block.minecraft.copper_bars": "Kupfagitter",
  "block.minecraft.copper_block": "Kupfablock",
  "block.minecraft.copper_bulb": "Kupfalampn",
  "block.minecraft.copper_chain": "Kupfakettn",
  "block.minecraft.copper_chest": "Kupfakistn",
  "block.minecraft.copper_door": "Kupfadia",
  "block.minecraft.copper_golem_statue": "Kupfagolemstatü",
  "block.minecraft.copper_grate": "Kupfagitter",
  "block.minecraft.copper_lantern": "Kupfalatarn",
  "block.minecraft.copper_ore": "Kupfaerz",
  "block.minecraft.copper_torch": "Kupfafackl",
  "block.minecraft.copper_trapdoor": "Kupfaklappdierl",
  "block.minecraft.copper_wall_torch": "Kupfawandfackl",
  "block.minecraft.cornflower": "Koanbleame",
  "block.minecraft.cracked_deepslate_bricks": "Rissige Diafnschiefazigl",
  "block.minecraft.cracked_deepslate_tiles": "Rissige Diafnschiefafliesn",
  "block.minecraft.cracked_nether_bricks": "Rissige Netherziegl",
  "block.minecraft.cracked_polished_blackstone_bricks": "Rissige polierte Schwoazstoaziegl",
  "block.minecraft.cracked_stone_bricks": "G’sprungane Stoazigl",
  "block.minecraft.crafter": "Handwerka",
  "block.minecraft.crafting_table": "Werkbank",
  "block.minecraft.creaking_heart": "Krachads Herz",
  "block.minecraft.creeper_head": "Creeperschädl",
  "block.minecraft.creeper_wall_head": "Creeper-Mauaschädl",
  "block.minecraft.crimson_button": "Karmesinknopf",
  "block.minecraft.crimson_door": "Karmesintia",
  "block.minecraft.crimson_fence": "Karmesinzaun",
  "block.minecraft.crimson_fence_gate": "Karmesinzauntor",
  "block.minecraft.crimson_fungus": "Karmesinschwammal",
  "block.minecraft.crimson_hanging_sign": "Karmesinhoizhängadsschuidl",
  "block.minecraft.crimson_hyphae": "Karmesinhyphn",
  "block.minecraft.crimson_nylium": "Karmesin-Nezel",
  "block.minecraft.crimson_planks": "Karmesinbretta",
  "block.minecraft.crimson_pressure_plate": "Karmesindruckplatte",
  "block.minecraft.crimson_roots": "Karmesinwuazn",
  "block.minecraft.crimson_shelf": "Karmesinhoizreagl",
  "block.minecraft.crimson_sign": "Karmesinschuid",
  "block.minecraft.crimson_slab": "Karmesinstufe",
  "block.minecraft.crimson_stairs": "Karmesinschdiang",
  "block.minecraft.crimson_stem": "Karmesinstamm",
  "block.minecraft.crimson_trapdoor": "Karmesinklappdierl",
  "block.minecraft.crimson_wall_hanging_sign": "Karmesinhoizwandhängadsschuidl",
  "block.minecraft.crimson_wall_sign": "Karmesinmauaschuid",
  "block.minecraft.crying_obsidian": "Weinenda Obsidian",
  "block.minecraft.cut_copper": "Geschnittena Kupfablock",
  "block.minecraft.cut_copper_slab": "Geschnittene Kupfastufe",
  "block.minecraft.cut_copper_stairs": "Geschnittene Kupfaschdiang",
  "block.minecraft.cut_red_sandstone": "G'schnittener rouder Sondstoa",
  "block.minecraft.cut_red_sandstone_slab": "G'schnittene roude Sondstoastufe",
  "block.minecraft.cut_sandstone": "G'schnittener Sondstoa",
  "block.minecraft.cut_sandstone_slab": "G'schnittene Sondstoastufe",
  "block.minecraft.cyan_banner": "Türkisa Banner",
  "block.minecraft.cyan_bed": "Türkis' Bett",
  "block.minecraft.cyan_candle": "Türkise Keaze",
  "block.minecraft.cyan_candle_cake": "Kuachn mid türkisa Keaze",
  "block.minecraft.cyan_carpet": "Türkisa Teppich",
  "block.minecraft.cyan_concrete": "Türkisa Bedau",
  "block.minecraft.cyan_concrete_powder": "Türkisa Trocknbedau",
  "block.minecraft.cyan_glazed_terracotta": "Türkise glasierte Keramik",
  "block.minecraft.cyan_shulker_box": "Türkise Shulker-Kiste",
  "block.minecraft.cyan_stained_glass": "Türkis' Glas",
  "block.minecraft.cyan_stained_glass_pane": "Türkise Glasscheibe",
  "block.minecraft.cyan_terracotta": "Türkis' Keramik",
  "block.minecraft.cyan_wool": "Türkise Wolle",
  "block.minecraft.damaged_anvil": "Beschädigta Amboss",
  "block.minecraft.dandelion": "Löwnzahn",
  "block.minecraft.dark_oak_button": "Schwoazoachenhoizknopf",
  "block.minecraft.dark_oak_door": "Schwoazoachenhoiztia",
  "block.minecraft.dark_oak_fence": "Schwoazoachnhoizzaun",
  "block.minecraft.dark_oak_fence_gate": "Schwoazoachnhoizzauntor",
  "block.minecraft.dark_oak_hanging_sign": "Schwoazoachnhoizhängadsschuidl",
  "block.minecraft.dark_oak_leaves": "Schwoazoachenlaub",
  "block.minecraft.dark_oak_log": "Schwoazoachenstamm",
  "block.minecraft.dark_oak_planks": "Schwoazoachenbretta",
  "block.minecraft.dark_oak_pressure_plate": "Schwoazoachenhoizdruckplatte",
  "block.minecraft.dark_oak_sapling": "Schwoazoachenzweigerl",
  "block.minecraft.dark_oak_shelf": "Schwoarzeichnhoizreagl",
  "block.minecraft.dark_oak_sign": "Schwoazoachenschuid",
  "block.minecraft.dark_oak_slab": "Schwoazoachenhoizstufe",
  "block.minecraft.dark_oak_stairs": "Schwoazoachenhoizschdiang",
  "block.minecraft.dark_oak_trapdoor": "Schwoazoachenhoizklappdierl",
  "block.minecraft.dark_oak_wall_hanging_sign": "Schwoazoachnhoizhängadsschuidl",
  "block.minecraft.dark_oak_wall_sign": "Schwoazoachenhoizmauaschuid",
  "block.minecraft.dark_oak_wood": "Schwoazoachenhoiz",
  "block.minecraft.dark_prismarine": "Dunkla Prismarin",
  "block.minecraft.dark_prismarine_slab": "Dunkle Prismarinstufe",
  "block.minecraft.dark_prismarine_stairs": "Dunkle Prismarinschdiang",
  "block.minecraft.daylight_detector": "Dogesliachtsensor",
  "block.minecraft.dead_brain_coral": "Doode Hirnkoralle",
  "block.minecraft.dead_brain_coral_block": "Doda Hirnkorallnblock",
  "block.minecraft.dead_brain_coral_fan": "Dooda Hirnkorallnfächa",
  "block.minecraft.dead_brain_coral_wall_fan": "Dooda Hirnkorallnwandfächa",
  "block.minecraft.dead_bubble_coral": "Doode Blasenkoralle",
  "block.minecraft.dead_bubble_coral_block": "Doda Blasenkorallnblock",
  "block.minecraft.dead_bubble_coral_fan": "Dooda Blasenkorallnfächa",
  "block.minecraft.dead_bubble_coral_wall_fan": "Dooda Blosnkorallnwandfächa",
  "block.minecraft.dead_bush": "Douda Busch",
  "block.minecraft.dead_fire_coral": "Doode Feierkoralle",
  "block.minecraft.dead_fire_coral_block": "Doda Feierkorallnblock",
  "block.minecraft.dead_fire_coral_fan": "Dooda Feuerkorallnfächa",
  "block.minecraft.dead_fire_coral_wall_fan": "Dooda Feiakorallnwandfächa",
  "block.minecraft.dead_horn_coral": "Doode Hornkoralle",
  "block.minecraft.dead_horn_coral_block": "Doda Hornkorallnblock",
  "block.minecraft.dead_horn_coral_fan": "Dooda Geweihkorallnfächa",
  "block.minecraft.dead_horn_coral_wall_fan": "Dooda Gweihkorallnwandfächa",
  "block.minecraft.dead_tube_coral": "Doode Orgelkoralle",
  "block.minecraft.dead_tube_coral_block": "Doda Orgelkorallnblock",
  "block.minecraft.dead_tube_coral_fan": "Dooda Orgelkorallenfächa",
  "block.minecraft.dead_tube_coral_wall_fan": "Dooda Orgelkorallnwandfächa",
  "block.minecraft.decorated_pot": "Verzierta Topf",
  "block.minecraft.deepslate": "Diafnschiefa",
  "block.minecraft.deepslate_brick_slab": "Diafnschiefaziglstufe",
  "block.minecraft.deepslate_brick_stairs": "Diafnschiefaziglschdiang",
  "block.minecraft.deepslate_brick_wall": "Diafnschiefaziglmaua",
  "block.minecraft.deepslate_bricks": "Diafnschiefazigl",
  "block.minecraft.deepslate_coal_ore": "Diafnschiefa-Stoankuin",
  "block.minecraft.deepslate_copper_ore": "Diafnschiefa-Kupfaerz",
  "block.minecraft.deepslate_diamond_ore": "Diafnschiefa-Diamanterz",
  "block.minecraft.deepslate_emerald_ore": "Diafnschiefa-Smaragderz",
  "block.minecraft.deepslate_gold_ore": "Diafnschiefa-Goiderz",
  "block.minecraft.deepslate_iron_ore": "Diafnschiefa-Eisenerz",
  "block.minecraft.deepslate_lapis_ore": "Diafnschiefa-Lapislazulierz",
  "block.minecraft.deepslate_redstone_ore": "Diafnschiefa-Redstone-Erz",
  "block.minecraft.deepslate_tile_slab": "Diafnschiefafliesnstufe",
  "block.minecraft.deepslate_tile_stairs": "Diafnschiefafliesnschdiang",
  "block.minecraft.deepslate_tile_wall": "Diafnschiefafliesnmaua",
  "block.minecraft.deepslate_tiles": "Diafnschiefafliesn",
  "block.minecraft.detector_rail": "Sensorschiene",
  "block.minecraft.diamond_block": "Diamantblock",
  "block.minecraft.diamond_ore": "Diamanterz",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Dioritstufn",
  "block.minecraft.diorite_stairs": "Dioritschdiang",
  "block.minecraft.diorite_wall": "Dioritmaua",
  "block.minecraft.dirt": "Eadn",
  "block.minecraft.dirt_path": "Tramplpfad",
  "block.minecraft.dispenser": "Werfa",
  "block.minecraft.dragon_egg": "Drachnoa",
  "block.minecraft.dragon_head": "Drachnschädl",
  "block.minecraft.dragon_wall_head": "Drachnmauaschädl",
  "block.minecraft.dried_ghast": "Ausdruckada Ghast",
  "block.minecraft.dried_kelp_block": "Getrockneta Seetangblock",
  "block.minecraft.dripstone_block": "Tropfstoanblock",
  "block.minecraft.dropper": "Spenda",
  "block.minecraft.emerald_block": "Smaragdblock",
  "block.minecraft.emerald_ore": "Smaragderz",
  "block.minecraft.enchanting_table": "Zaubadisch",
  "block.minecraft.end_gateway": "Endtransitportal",
  "block.minecraft.end_portal": "Endportal",
  "block.minecraft.end_portal_frame": "Endportalrahmen",
  "block.minecraft.end_rod": "Endstob",
  "block.minecraft.end_stone": "Endstoa",
  "block.minecraft.end_stone_brick_slab": "Endstoazieglstufn",
  "block.minecraft.end_stone_brick_stairs": "Endstoazieglschdiang",
  "block.minecraft.end_stone_brick_wall": "Endstoizieglmaua",
  "block.minecraft.end_stone_bricks": "Endstoaziegl",
  "block.minecraft.ender_chest": "Endertruhe",
  "block.minecraft.exposed_chiseled_copper": "Oglafana Gmeißelta Kupfablock",
  "block.minecraft.exposed_copper": "Angelaufena Kupfablock",
  "block.minecraft.exposed_copper_bars": "Aglaufens Kupfagitter",
  "block.minecraft.exposed_copper_bulb": "Oglafane Kupfalampn",
  "block.minecraft.exposed_copper_chain": "Aglaufene Kupfakettn",
  "block.minecraft.exposed_copper_chest": "Aglaufene Kupfakistn",
  "block.minecraft.exposed_copper_door": "Oglafane Kupfadia",
  "block.minecraft.exposed_copper_golem_statue": "Aglaufene Kupfagolemstatue",
  "block.minecraft.exposed_copper_grate": "Oglafans Kupfagitter",
  "block.minecraft.exposed_copper_lantern": "Aglaufene Kupfalatarn",
  "block.minecraft.exposed_copper_trapdoor": "Oglafans Kupfaklapodierl",
  "block.minecraft.exposed_cut_copper": "Ang'laufena g'schnittena Kupfablock",
  "block.minecraft.exposed_cut_copper_slab": "Ang'laufene g'schnittene Kupfastufe",
  "block.minecraft.exposed_cut_copper_stairs": "Ang'laufene g'schnittene Kupfaschdiang",
  "block.minecraft.exposed_lightning_rod": "Aglaufener Blitzobleida",
  "block.minecraft.farmland": "Ackabodn",
  "block.minecraft.fern": "Farn",
  "block.minecraft.fire": "Feia",
  "block.minecraft.fire_coral": "Feierkoralle",
  "block.minecraft.fire_coral_block": "Feierkorallnblock",
  "block.minecraft.fire_coral_fan": "Feierkorallnfächer",
  "block.minecraft.fire_coral_wall_fan": "Feiakorallnwandfächa",
  "block.minecraft.firefly_bush": "Glüweamal Busch",
  "block.minecraft.fletching_table": "Bognadisch",
  "block.minecraft.flower_pot": "Bleamentopf",
  "block.minecraft.flowering_azalea": "Blühnde Azalee",
  "block.minecraft.flowering_azalea_leaves": "Blühende Azaleenbladl",
  "block.minecraft.frogspawn": "Froschloach",
  "block.minecraft.frosted_ice": "Brüchiges Eis",
  "block.minecraft.furnace": "Ofn",
  "block.minecraft.gilded_blackstone": "Goidduachzogena Schwoazstoa",
  "block.minecraft.glass": "Glos",
  "block.minecraft.glass_pane": "Glasscheibe",
  "block.minecraft.glow_lichen": "Leichtflechte",
  "block.minecraft.glowstone": "Leichtstoa",
  "block.minecraft.gold_block": "Goidblock",
  "block.minecraft.gold_ore": "Goiderz",
  "block.minecraft.golden_dandelion": "Goidlöwnzahn",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Granitstufe",
  "block.minecraft.granite_stairs": "Granitschdiang",
  "block.minecraft.granite_wall": "Grantimaua",
  "block.minecraft.grass": "Gras",
  "block.minecraft.grass_block": "Grasblock",
  "block.minecraft.gravel": "Kies",
  "block.minecraft.gray_banner": "Graus Banner",
  "block.minecraft.gray_bed": "Graus Bett",
  "block.minecraft.gray_candle": "Graue Keaze",
  "block.minecraft.gray_candle_cake": "Kuachn mid graua Keaze",
  "block.minecraft.gray_carpet": "Graua Teppich",
  "block.minecraft.gray_concrete": "Graua Bedau",
  "block.minecraft.gray_concrete_powder": "Graua Trocknbedau",
  "block.minecraft.gray_glazed_terracotta": "Graue glasierte Keramik",
  "block.minecraft.gray_shulker_box": "Graue Shulker-Kiste",
  "block.minecraft.gray_stained_glass": "Graus Glas",
  "block.minecraft.gray_stained_glass_pane": "Graue Glasscheibe",
  "block.minecraft.gray_terracotta": "Graus Keramik",
  "block.minecraft.gray_wool": "Graue Wolle",
  "block.minecraft.green_banner": "Greana Banner",
  "block.minecraft.green_bed": "Greans Bett",
  "block.minecraft.green_candle": "Greane Keaze",
  "block.minecraft.green_candle_cake": "Kuachn mid greana Keaze",
  "block.minecraft.green_carpet": "Greana Teppich",
  "block.minecraft.green_concrete": "Greana Bedau",
  "block.minecraft.green_concrete_powder": "Greana Trocknbedau",
  "block.minecraft.green_glazed_terracotta": "Greane glasierte Keramik",
  "block.minecraft.green_shulker_box": "Greane Shulker-Kiste",
  "block.minecraft.green_stained_glass": "Greans Glas",
  "block.minecraft.green_stained_glass_pane": "Greane Glasscheibe",
  "block.minecraft.green_terracotta": "Greans Keramik",
  "block.minecraft.green_wool": "Greane Wolle",
  "block.minecraft.grindstone": "Schleifstoa",
  "block.minecraft.hanging_roots": "Hängende Wurzeln",
  "block.minecraft.hay_block": "Strohboin",
  "block.minecraft.heavy_core": "Schwara Kean",
  "block.minecraft.heavy_weighted_pressure_plate": "Grobwägeplatte",
  "block.minecraft.honey_block": "Honiblock",
  "block.minecraft.honeycomb_block": "Honiwabnblock",
  "block.minecraft.hopper": "Trichta",
  "block.minecraft.horn_coral": "Hornkoralle",
  "block.minecraft.horn_coral_block": "Hornkorallnblock",
  "block.minecraft.horn_coral_fan": "Hornkorallnfächer",
  "block.minecraft.horn_coral_wall_fan": "Gweihkorallnwandfächa",
  "block.minecraft.ice": "Eis",
  "block.minecraft.infested_chiseled_stone_bricks": "B’foine G’meißlte Stoazigl",
  "block.minecraft.infested_cobblestone": "B’foina Bruchstoa",
  "block.minecraft.infested_cracked_stone_bricks": "B’foine G’sprungane Stoazigl",
  "block.minecraft.infested_deepslate": "Befallena Diafnschiefa",
  "block.minecraft.infested_mossy_stone_bricks": "B’foine Vamooste Stoazigl",
  "block.minecraft.infested_stone": "B’foiner Stoa",
  "block.minecraft.infested_stone_bricks": "B’foine Stoazigl",
  "block.minecraft.iron_bars": "Eisengitta",
  "block.minecraft.iron_block": "Eisenblock",
  "block.minecraft.iron_chain": "Eisnkettn",
  "block.minecraft.iron_door": "Eisentia",
  "block.minecraft.iron_ore": "Eisenerz",
  "block.minecraft.iron_trapdoor": "Eisenklappdierl",
  "block.minecraft.jack_o_lantern": "Kürbislaterne",
  "block.minecraft.jigsaw": "Verbundblock",
  "block.minecraft.jukebox": "Plattnspiela",
  "block.minecraft.jungle_button": "Tropnhoizknopf",
  "block.minecraft.jungle_door": "Tropnhoiztia",
  "block.minecraft.jungle_fence": "Tropnhoizzaun",
  "block.minecraft.jungle_fence_gate": "Tropnhoizzauntor",
  "block.minecraft.jungle_hanging_sign": "Tropnhoizhängadsschuidl",
  "block.minecraft.jungle_leaves": "Tropnbaamlaub",
  "block.minecraft.jungle_log": "Tropnbaamstamm",
  "block.minecraft.jungle_planks": "Tropnhoizbretta",
  "block.minecraft.jungle_pressure_plate": "Tropnhoizdruckplatte",
  "block.minecraft.jungle_sapling": "Tropnbaamzweigerl",
  "block.minecraft.jungle_shelf": "Tropnhoizreagl",
  "block.minecraft.jungle_sign": "Tropnhoizschuidl",
  "block.minecraft.jungle_slab": "Tropnhoizstufe",
  "block.minecraft.jungle_stairs": "Tropnhoizschdiang",
  "block.minecraft.jungle_trapdoor": "Tropnhoizklappdierl",
  "block.minecraft.jungle_wall_hanging_sign": "Tropnhoizwandhängadsschuidl",
  "block.minecraft.jungle_wall_sign": "Tropnhoizmauaschuid",
  "block.minecraft.jungle_wood": "Tropnhoiz",
  "block.minecraft.kelp": "Seetang",
  "block.minecraft.kelp_plant": "Seetangstängl",
  "block.minecraft.ladder": "Leita",
  "block.minecraft.lantern": "Laterne",
  "block.minecraft.lapis_block": "Lapislazuliblock",
  "block.minecraft.lapis_ore": "Lapislazulierz",
  "block.minecraft.large_amethyst_bud": "Große Amethystknospe",
  "block.minecraft.large_fern": "Großer Farn",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lavakessl",
  "block.minecraft.leaf_litter": "Laban",
  "block.minecraft.lectern": "Lesepuit",
  "block.minecraft.lever": "Hebl",
  "block.minecraft.light": "Liachtblock",
  "block.minecraft.light_blue_banner": "Höiblaua Banner",
  "block.minecraft.light_blue_bed": "Höiblaues Bett",
  "block.minecraft.light_blue_candle": "Höiblaue Keaze",
  "block.minecraft.light_blue_candle_cake": "Kuachn mid höiblaua Keaze",
  "block.minecraft.light_blue_carpet": "Höiblaua Teppich",
  "block.minecraft.light_blue_concrete": "Höiblaua Bedau",
  "block.minecraft.light_blue_concrete_powder": "Höiblaua Trocknbedau",
  "block.minecraft.light_blue_glazed_terracotta": "Höiblaue glasierte Keramik",
  "block.minecraft.light_blue_shulker_box": "Höiblaue Shulker-Kiste",
  "block.minecraft.light_blue_stained_glass": "Höiblaues Glas",
  "block.minecraft.light_blue_stained_glass_pane": "Höiblaue Glasscheibe",
  "block.minecraft.light_blue_terracotta": "Höiblaues Keramik",
  "block.minecraft.light_blue_wool": "Höiblaue Wolle",
  "block.minecraft.light_gray_banner": "Höigraua Banner",
  "block.minecraft.light_gray_bed": "Höigraues Bett",
  "block.minecraft.light_gray_candle": "Höigraue Keaze",
  "block.minecraft.light_gray_candle_cake": "Kuachn mid höigraua Keaze",
  "block.minecraft.light_gray_carpet": "Höigraua Teppich",
  "block.minecraft.light_gray_concrete": "Höigraua Bedau",
  "block.minecraft.light_gray_concrete_powder": "Höigraua Trocknbedau",
  "block.minecraft.light_gray_glazed_terracotta": "Höigraue glasierte Keramik",
  "block.minecraft.light_gray_shulker_box": "Höigraue Shulker-Kiste",
  "block.minecraft.light_gray_stained_glass": "Höigraues Glas",
  "block.minecraft.light_gray_stained_glass_pane": "Höigraue Glasscheibe",
  "block.minecraft.light_gray_terracotta": "Höigraues Keramik",
  "block.minecraft.light_gray_wool": "Höigraue Wolle",
  "block.minecraft.light_weighted_pressure_plate": "Feinwägeplatte",
  "block.minecraft.lightning_rod": "Blitzableita",
  "block.minecraft.lilac": "Flieda",
  "block.minecraft.lily_of_the_valley": "Maigleggal",
  "block.minecraft.lily_pad": "Seerosnbladdl",
  "block.minecraft.lime_banner": "Giftgreana Banner",
  "block.minecraft.lime_bed": "Giftgreans Bett",
  "block.minecraft.lime_candle": "Giftgreane Keaze",
  "block.minecraft.lime_candle_cake": "Kuachn mid giftgreana Keaze",
  "block.minecraft.lime_carpet": "Giftgreana Teppich",
  "block.minecraft.lime_concrete": "Giftgreana Bedau",
  "block.minecraft.lime_concrete_powder": "Giftgreana Trocknbedau",
  "block.minecraft.lime_glazed_terracotta": "Giftgreane glasierte Keramik",
  "block.minecraft.lime_shulker_box": "Giftgreane Shulker-Kiste",
  "block.minecraft.lime_stained_glass": "Giftgreans Glas",
  "block.minecraft.lime_stained_glass_pane": "Giftgreane Glasscheibe",
  "block.minecraft.lime_terracotta": "Giftgreans Keramik",
  "block.minecraft.lime_wool": "Giftgreane Wolle",
  "block.minecraft.lodestone": "Leitstoa",
  "block.minecraft.loom": "Webstui",
  "block.minecraft.magenta_banner": "Magenta Banner",
  "block.minecraft.magenta_bed": "Magenta Bett",
  "block.minecraft.magenta_candle": "Magenta Keaze",
  "block.minecraft.magenta_candle_cake": "Kuachn mid magenta Keaze",
  "block.minecraft.magenta_carpet": "Magenta Teppich",
  "block.minecraft.magenta_concrete": "Magenta Bedau",
  "block.minecraft.magenta_concrete_powder": "Magenta Trocknbedau",
  "block.minecraft.magenta_glazed_terracotta": "Magenta glasierte Keramik",
  "block.minecraft.magenta_shulker_box": "Magenta Shulker-Kiste",
  "block.minecraft.magenta_stained_glass": "Magenta Glas",
  "block.minecraft.magenta_stained_glass_pane": "Magenta Glasscheibe",
  "block.minecraft.magenta_terracotta": "Magenta Keramik",
  "block.minecraft.magenta_wool": "Magenta Wolle",
  "block.minecraft.magma_block": "Magmablock",
  "block.minecraft.mangrove_button": "Mangrovenhoizknopf",
  "block.minecraft.mangrove_door": "Mangrovendia",
  "block.minecraft.mangrove_fence": "Mangrovenhoizzaun",
  "block.minecraft.mangrove_fence_gate": "Mangrovenhoizzauntor",
  "block.minecraft.mangrove_hanging_sign": "Mangrovenhoizhängadsschuidl",
  "block.minecraft.mangrove_leaves": "Mangrovenbladl",
  "block.minecraft.mangrove_log": "Mangrovenstamm",
  "block.minecraft.mangrove_planks": "Magrovn'breda",
  "block.minecraft.mangrove_pressure_plate": "Mangrovenhoizdruckplattn",
  "block.minecraft.mangrove_propagule": "Mangroven-Keimling",
  "block.minecraft.mangrove_roots": "Mangrovenwurzn",
  "block.minecraft.mangrove_shelf": "Mangrovenhoizreagl",
  "block.minecraft.mangrove_sign": "Mangrovenschuidl",
  "block.minecraft.mangrove_slab": "Mangrovenhoizstufe",
  "block.minecraft.mangrove_stairs": "Mangrovenhoiztreppn",
  "block.minecraft.mangrove_trapdoor": "Mangrovenhoizklappdierl",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrovenhoizwandhängadsschuidl",
  "block.minecraft.mangrove_wall_sign": "Mangrovenhoizwandschuidl",
  "block.minecraft.mangrove_wood": "Mangrovenhoiz",
  "block.minecraft.medium_amethyst_bud": "Mittlere Amethystknospe",
  "block.minecraft.melon": "Melone",
  "block.minecraft.melon_stem": "Melonenpflanzna",
  "block.minecraft.moss_block": "Moosblock",
  "block.minecraft.moss_carpet": "Moosteppich",
  "block.minecraft.mossy_cobblestone": "Bemooster Bruchstoa",
  "block.minecraft.mossy_cobblestone_slab": "Bemooste Bruchstoastufn",
  "block.minecraft.mossy_cobblestone_stairs": "Bemooste Bruchstoaschdiang",
  "block.minecraft.mossy_cobblestone_wall": "Bemooste Bruchstoamaua",
  "block.minecraft.mossy_stone_brick_slab": "Bemooste Stoizieglstufn",
  "block.minecraft.mossy_stone_brick_stairs": "Bemooste Stoazieglschdiang",
  "block.minecraft.mossy_stone_brick_wall": "Bemooste Stoizieglmaua",
  "block.minecraft.mossy_stone_bricks": "Vamoosta Stoazigl",
  "block.minecraft.moving_piston": "Bewegta Block",
  "block.minecraft.mud": "Matsch",
  "block.minecraft.mud_brick_slab": "Matschzichelstufn",
  "block.minecraft.mud_brick_stairs": "Matschziecheltreppe",
  "block.minecraft.mud_brick_wall": "Matschziechelmauer",
  "block.minecraft.mud_bricks": "Matschziechel",
  "block.minecraft.muddy_mangrove_roots": "Matschige Mangrovenwurzn",
  "block.minecraft.mushroom_stem": "Schwammalstil",
  "block.minecraft.mycelium": "Myzel",
  "block.minecraft.nether_brick_fence": "Netherzieglzaun",
  "block.minecraft.nether_brick_slab": "Netherzieglstufe",
  "block.minecraft.nether_brick_stairs": "Netherzieglschdiang",
  "block.minecraft.nether_brick_wall": "Netherzieglmaua",
  "block.minecraft.nether_bricks": "Netherziegl",
  "block.minecraft.nether_gold_ore": "Nethergoiderz",
  "block.minecraft.nether_portal": "Netherportal",
  "block.minecraft.nether_quartz_ore": "Netherquarzerz",
  "block.minecraft.nether_sprouts": "Nethersprosse",
  "block.minecraft.nether_wart": "Netherwarzn",
  "block.minecraft.nether_wart_block": "Netherwarznblock",
  "block.minecraft.netherite_block": "Netheritblock",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Notnblock",
  "block.minecraft.oak_button": "Oachenhoizknopf",
  "block.minecraft.oak_door": "Oachenhoiztia",
  "block.minecraft.oak_fence": "Oachnhoizzaun",
  "block.minecraft.oak_fence_gate": "Oachnhoizzauntor",
  "block.minecraft.oak_hanging_sign": "Oachnhoizhängadsschuidl",
  "block.minecraft.oak_leaves": "Oachenlaub",
  "block.minecraft.oak_log": "Oachenstamm",
  "block.minecraft.oak_planks": "Oachenhoizbretta",
  "block.minecraft.oak_pressure_plate": "Oachenhoizdruckplatte",
  "block.minecraft.oak_sapling": "Oachenzweigerl",
  "block.minecraft.oak_shelf": "Eichnhoizreagl",
  "block.minecraft.oak_sign": "Oachenhoizschuid",
  "block.minecraft.oak_slab": "Oachenstufe",
  "block.minecraft.oak_stairs": "Oachenhoizschdiang",
  "block.minecraft.oak_trapdoor": "Oachenhoizklappdierl",
  "block.minecraft.oak_wall_hanging_sign": "Oachnhoizwandhängadsschuidl",
  "block.minecraft.oak_wall_sign": "Oachenhoizmauaschuid",
  "block.minecraft.oak_wood": "Oachenhoiz",
  "block.minecraft.observer": "Beobachta",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Ockerns Froschliacht",
  "block.minecraft.ominous_banner": "Unheilvolles Banner",
  "block.minecraft.open_eyeblossom": "Offane Augnbliatn",
  "block.minecraft.orange_banner": "Orangschener Banner",
  "block.minecraft.orange_bed": "Oranges Bett",
  "block.minecraft.orange_candle": "Orange Keaze",
  "block.minecraft.orange_candle_cake": "Kuachn mid oranga Keaze",
  "block.minecraft.orange_carpet": "Oranga Teppich",
  "block.minecraft.orange_concrete": "Oranga Bedau",
  "block.minecraft.orange_concrete_powder": "Oranga Trocknbedau",
  "block.minecraft.orange_glazed_terracotta": "Orange glasierte Keramik",
  "block.minecraft.orange_shulker_box": "Orange Shulker-Kiste",
  "block.minecraft.orange_stained_glass": "Oranges Glas",
  "block.minecraft.orange_stained_glass_pane": "Orange Glasscheibe",
  "block.minecraft.orange_terracotta": "Oranges Keramik",
  "block.minecraft.orange_tulip": "Orange Tulpe",
  "block.minecraft.orange_wool": "Orange Wolle",
  "block.minecraft.oxeye_daisy": "Margerite",
  "block.minecraft.oxidized_chiseled_copper": "Oxidierta Gmeißelta Kupfablock",
  "block.minecraft.oxidized_copper": "Oxidiata Kupfablock",
  "block.minecraft.oxidized_copper_bars": "Oxidiats Kupfagitter",
  "block.minecraft.oxidized_copper_bulb": "Oxidiate Kupfalampn",
  "block.minecraft.oxidized_copper_chain": "Oxidiate Kupfakettn",
  "block.minecraft.oxidized_copper_chest": "Oxidiate Kupfakistn",
  "block.minecraft.oxidized_copper_door": "Oxidierte Kupfadia",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidiate Kupfergolemstatü",
  "block.minecraft.oxidized_copper_grate": "Oxidierts Kupfagitter",
  "block.minecraft.oxidized_copper_lantern": "Oxidiate Kupfalatarn",
  "block.minecraft.oxidized_copper_trapdoor": "Oxidierts Kupfaklappdierl",
  "block.minecraft.oxidized_cut_copper": "Oxidiata g'schnittena Kupfablock",
  "block.minecraft.oxidized_cut_copper_slab": "Oxidiate g'schnittene Kupfastufe",
  "block.minecraft.oxidized_cut_copper_stairs": "Oxidiate g'schnittene Kupfaschdiang",
  "block.minecraft.oxidized_lightning_rod": "Oxidiater Blitzobleida",
  "block.minecraft.packed_ice": "Packeis",
  "block.minecraft.packed_mud": "Fester Matsch",
  "block.minecraft.pale_hanging_moss": "Heis Hängads Moos",
  "block.minecraft.pale_moss_block": "Heia Moosblock",
  "block.minecraft.pale_moss_carpet": "Heia Mossteppich",
  "block.minecraft.pale_oak_button": "Heia Oachnknopf",
  "block.minecraft.pale_oak_door": "Heie Oachndia",
  "block.minecraft.pale_oak_fence": "Heia Oachnzaun",
  "block.minecraft.pale_oak_fence_gate": "Heis Ochnzaundial",
  "block.minecraft.pale_oak_hanging_sign": "Heis Oachnhoizhängadsschuidl",
  "block.minecraft.pale_oak_leaves": "Heis Oachnlaub",
  "block.minecraft.pale_oak_log": "Heia Oachnstamm",
  "block.minecraft.pale_oak_planks": "Heie Oachnbretta",
  "block.minecraft.pale_oak_pressure_plate": "Heie Oachndruckplattn",
  "block.minecraft.pale_oak_sapling": "Heia Oachnzweigerl",
  "block.minecraft.pale_oak_shelf": "Blass Eichnhoizreagl",
  "block.minecraft.pale_oak_sign": "Heis Oachnschuidl",
  "block.minecraft.pale_oak_slab": "Heia Oachnhoizstufe",
  "block.minecraft.pale_oak_stairs": "Heia Oachnhoizschdiang",
  "block.minecraft.pale_oak_trapdoor": "Heia Oachnhoizklappdierl",
  "block.minecraft.pale_oak_wall_hanging_sign": "Heia Oachnhoizhängadsschuidl",
  "block.minecraft.pale_oak_wall_sign": "Heia Oachnhoizschuidl",
  "block.minecraft.pale_oak_wood": "Heia Oachnhoiz",
  "block.minecraft.pearlescent_froglight": "Perlmutt Froschliacht",
  "block.minecraft.peony": "Pfingstrose",
  "block.minecraft.petrified_oak_slab": "Verstoanate Oachenhoizstufe",
  "block.minecraft.piglin_head": "Piglinschädl",
  "block.minecraft.piglin_wall_head": "Piglinwandschädl",
  "block.minecraft.pink_banner": "Rosa Banner",
  "block.minecraft.pink_bed": "Rosa Bett",
  "block.minecraft.pink_candle": "Rosa Keaze",
  "block.minecraft.pink_candle_cake": "Kuachn mid rosa Keaze",
  "block.minecraft.pink_carpet": "Rosa Teppich",
  "block.minecraft.pink_concrete": "Rosa Bedau",
  "block.minecraft.pink_concrete_powder": "Rosa Trocknbedau",
  "block.minecraft.pink_glazed_terracotta": "Rosa glasierte Keramik",
  "block.minecraft.pink_petals": "Rosa Bliatenblätter",
  "block.minecraft.pink_shulker_box": "Rosa Shulker-Kiste",
  "block.minecraft.pink_stained_glass": "Rosa Glas",
  "block.minecraft.pink_stained_glass_pane": "Rosa Glasscheibe",
  "block.minecraft.pink_terracotta": "Rosa Keramik",
  "block.minecraft.pink_tulip": "Rosa Tulpe",
  "block.minecraft.pink_wool": "Rosa Wolle",
  "block.minecraft.piston": "Kolbn",
  "block.minecraft.piston_head": "Kolbnschädl",
  "block.minecraft.pitcher_crop": "Kannenbleamesamen",
  "block.minecraft.pitcher_plant": "Kannenbleame",
  "block.minecraft.player_head": "Spielaschädl",
  "block.minecraft.player_head.named": "Schädl vo %s",
  "block.minecraft.player_wall_head": "Spielamauaschädl",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Spitza Tropfstoan",
  "block.minecraft.polished_andesite": "Polierta Andesit",
  "block.minecraft.polished_andesite_slab": "Polierte Andesitstufe",
  "block.minecraft.polished_andesite_stairs": "Polierte Andesitschdiang",
  "block.minecraft.polished_basalt": "Polierta Basalt",
  "block.minecraft.polished_blackstone": "Polierta Schwoazstoa",
  "block.minecraft.polished_blackstone_brick_slab": "Polierte Schwoazstoazieglstufe",
  "block.minecraft.polished_blackstone_brick_stairs": "Polierte Schwoazstoazieglschdiang",
  "block.minecraft.polished_blackstone_brick_wall": "Polierte Schwoazstoazieglmaua",
  "block.minecraft.polished_blackstone_bricks": "Polierte Schwoazstoaziegl",
  "block.minecraft.polished_blackstone_button": "Polierta Schwoazstoaknopf",
  "block.minecraft.polished_blackstone_pressure_plate": "Polierte Schwoazstoadruckplatte",
  "block.minecraft.polished_blackstone_slab": "Polierte Schwoazstoastufe",
  "block.minecraft.polished_blackstone_stairs": "Polierte Schwoazstoaschdiang",
  "block.minecraft.polished_blackstone_wall": "Polierte Schwoazstoamaua",
  "block.minecraft.polished_deepslate": "Polierta Diafnschiefa",
  "block.minecraft.polished_deepslate_slab": "Polierte Diafnschiefastufe",
  "block.minecraft.polished_deepslate_stairs": "Polierte Diafnschiefaschdiang",
  "block.minecraft.polished_deepslate_wall": "Polierte Diafnschiefamaua",
  "block.minecraft.polished_diorite": "Polierta Diorit",
  "block.minecraft.polished_diorite_slab": "Polierte Dioritstufe",
  "block.minecraft.polished_diorite_stairs": "Polierte Dioritschdiang",
  "block.minecraft.polished_granite": "Polierta Granit",
  "block.minecraft.polished_granite_slab": "Polierte Granitstufe",
  "block.minecraft.polished_granite_stairs": "Polierte Granitschdiang",
  "block.minecraft.polished_tuff": "Polierta Tuffstoa",
  "block.minecraft.polished_tuff_slab": "Polierte Tuffstufn",
  "block.minecraft.polished_tuff_stairs": "Polierte Tuffstiagn",
  "block.minecraft.polished_tuff_wall": "Polierte Tuffmauer",
  "block.minecraft.poppy": "Mohn",
  "block.minecraft.potatoes": "Eadäpfe",
  "block.minecraft.potted_acacia_sapling": "Eidopfta Akazienzweigerl",
  "block.minecraft.potted_allium": "Eidopfta Steanlauch",
  "block.minecraft.potted_azalea_bush": "Eidopfte Azalee",
  "block.minecraft.potted_azure_bluet": "Eidopftes Porzellansteanchn",
  "block.minecraft.potted_bamboo": "Eidopfta Bambus",
  "block.minecraft.potted_birch_sapling": "Eidopfta Birknzweigerl",
  "block.minecraft.potted_blue_orchid": "Eidopfte blaue Oachidee",
  "block.minecraft.potted_brown_mushroom": "Eidopfta brauna Schwammal",
  "block.minecraft.potted_cactus": "Eidopfta Kaktää",
  "block.minecraft.potted_cherry_sapling": "Eidopfta Kiaschzweigerl",
  "block.minecraft.potted_closed_eyeblossom": "Eipflanzte gschlossane Augnbleame",
  "block.minecraft.potted_cornflower": "Eidopfte Koanbleame",
  "block.minecraft.potted_crimson_fungus": "Eidopfta Karmesinschwammal",
  "block.minecraft.potted_crimson_roots": "Eidopfte Karmesinwuazn",
  "block.minecraft.potted_dandelion": "Eidopfta Löwnzahn",
  "block.minecraft.potted_dark_oak_sapling": "Eidopfta Schwoazoachenzweigerl",
  "block.minecraft.potted_dead_bush": "Eidopfta douda Busch",
  "block.minecraft.potted_fern": "Eidopfta Farn",
  "block.minecraft.potted_flowering_azalea_bush": "Eidopfte blühnde Azalee",
  "block.minecraft.potted_golden_dandelion": "Eidopfta Goidlöwnzahn",
  "block.minecraft.potted_jungle_sapling": "Eidopfta Tropnbaamzweigerl",
  "block.minecraft.potted_lily_of_the_valley": "Eidopftes Maiglöckchn",
  "block.minecraft.potted_mangrove_propagule": "Eitopfta Mangroven-Keimling",
  "block.minecraft.potted_oak_sapling": "Eidopfta Oachenzweigerl",
  "block.minecraft.potted_open_eyeblossom": "Eipflanzte offane Augnbleame",
  "block.minecraft.potted_orange_tulip": "Eidopfte orange Tulpe",
  "block.minecraft.potted_oxeye_daisy": "Eidopfte Margerite",
  "block.minecraft.potted_pale_oak_sapling": "Eipflanzta Heia Oachnsetzling",
  "block.minecraft.potted_pink_tulip": "Eidopfte rosa Tulpe",
  "block.minecraft.potted_poppy": "Eidopfta Mohn",
  "block.minecraft.potted_red_mushroom": "Eidopfta rouda Schwammal",
  "block.minecraft.potted_red_tulip": "Eidopfte roude Tulpe",
  "block.minecraft.potted_spruce_sapling": "Eidopfta Fichtnzweigerl",
  "block.minecraft.potted_torchflower": "Eitopfte Fackelbleame",
  "block.minecraft.potted_warped_fungus": "Eidopfta Wirrschwammal",
  "block.minecraft.potted_warped_roots": "Eidopfte Wirrwuazn",
  "block.minecraft.potted_white_tulip": "Eidopfte weiße Tulpe",
  "block.minecraft.potted_wither_rose": "Eidopfte Witherrose",
  "block.minecraft.powder_snow": "Pulvaschnää",
  "block.minecraft.powder_snow_cauldron": "Pulvaschnääkessl",
  "block.minecraft.powered_rail": "Antriebsschiene",
  "block.minecraft.prismarine": "Prismarin",
  "block.minecraft.prismarine_brick_slab": "Prismarinzieglstufe",
  "block.minecraft.prismarine_brick_stairs": "Prismarinzieglschdiang",
  "block.minecraft.prismarine_bricks": "Prismarinziegl",
  "block.minecraft.prismarine_slab": "Prismarinstufe",
  "block.minecraft.prismarine_stairs": "Prismarinschdiang",
  "block.minecraft.prismarine_wall": "Prismarinmaua",
  "block.minecraft.pumpkin": "Kürbis",
  "block.minecraft.pumpkin_stem": "Kürbispflanzna",
  "block.minecraft.purple_banner": "Lila Banner",
  "block.minecraft.purple_bed": "Lila Bett",
  "block.minecraft.purple_candle": "Violette Keaze",
  "block.minecraft.purple_candle_cake": "Kuachn mid lila Keaze",
  "block.minecraft.purple_carpet": "Violetta Teppich",
  "block.minecraft.purple_concrete": "Violetta Bedau",
  "block.minecraft.purple_concrete_powder": "Violetta Trocknbedau",
  "block.minecraft.purple_glazed_terracotta": "Violette glasierte Keramik",
  "block.minecraft.purple_shulker_box": "Violette Shulker-Kiste",
  "block.minecraft.purple_stained_glass": "Violetts Glas",
  "block.minecraft.purple_stained_glass_pane": "Violette Glasscheibe",
  "block.minecraft.purple_terracotta": "Violetts Keramik",
  "block.minecraft.purple_wool": "Violette Wolle",
  "block.minecraft.purpur_block": "Purpurblock",
  "block.minecraft.purpur_pillar": "Purpursäule",
  "block.minecraft.purpur_slab": "Purpurstufe",
  "block.minecraft.purpur_stairs": "Purpurschdiang",
  "block.minecraft.quartz_block": "Quarzblock",
  "block.minecraft.quartz_bricks": "Quarzziegl",
  "block.minecraft.quartz_pillar": "Quarzsäule",
  "block.minecraft.quartz_slab": "Quarzstufe",
  "block.minecraft.quartz_stairs": "Quarzschdiang",
  "block.minecraft.rail": "Schiene",
  "block.minecraft.raw_copper_block": "Rohkupfablock",
  "block.minecraft.raw_gold_block": "Rohgoidblock",
  "block.minecraft.raw_iron_block": "Roheisenblock",
  "block.minecraft.red_banner": "Rouda Banner",
  "block.minecraft.red_bed": "Rouds Bett",
  "block.minecraft.red_candle": "Roude Keaze",
  "block.minecraft.red_candle_cake": "Kuachn mid rouda Keaze",
  "block.minecraft.red_carpet": "Rouda Teppich",
  "block.minecraft.red_concrete": "Rouda Bedau",
  "block.minecraft.red_concrete_powder": "Rouda Trocknbedau",
  "block.minecraft.red_glazed_terracotta": "Roude glasierte Keramik",
  "block.minecraft.red_mushroom": "Rouda Schwammal",
  "block.minecraft.red_mushroom_block": "Rouda Schwammalblock",
  "block.minecraft.red_nether_brick_slab": "Rode Netherzieglschdiang",
  "block.minecraft.red_nether_brick_stairs": "Roude Netherzieglschdiang",
  "block.minecraft.red_nether_brick_wall": "Rode Netherzieglmaua",
  "block.minecraft.red_nether_bricks": "Roude Netherziegl",
  "block.minecraft.red_sand": "Rouda Sond",
  "block.minecraft.red_sandstone": "Rouda Sondstoa",
  "block.minecraft.red_sandstone_slab": "Rote Sandstoastufe",
  "block.minecraft.red_sandstone_stairs": "Roude Sondstoaschdiang",
  "block.minecraft.red_sandstone_wall": "Roude Sondstoamaua",
  "block.minecraft.red_shulker_box": "Roude Shulker-Kiste",
  "block.minecraft.red_stained_glass": "Rouds Glas",
  "block.minecraft.red_stained_glass_pane": "Roude Glasscheibe",
  "block.minecraft.red_terracotta": "Rouds Keramik",
  "block.minecraft.red_tulip": "Roude Tulpe",
  "block.minecraft.red_wool": "Roude Wolle",
  "block.minecraft.redstone_block": "Redstone-Block",
  "block.minecraft.redstone_lamp": "Redstone-Lampe",
  "block.minecraft.redstone_ore": "Redstone-Erz",
  "block.minecraft.redstone_torch": "Redstone-Fackel",
  "block.minecraft.redstone_wall_torch": "Redstone-Mauafackel",
  "block.minecraft.redstone_wire": "Redstone-Leitung",
  "block.minecraft.reinforced_deepslate": "Verstärkta Diafnschiefa",
  "block.minecraft.repeater": "Redstone Verstärka",
  "block.minecraft.repeating_command_block": "Wiedahol-Befehlsblock",
  "block.minecraft.resin_block": "Harzblock",
  "block.minecraft.resin_brick_slab": "Harzzieglstufe",
  "block.minecraft.resin_brick_stairs": "Harzzieglschdiang",
  "block.minecraft.resin_brick_wall": "Harzzieglmaua",
  "block.minecraft.resin_bricks": "Harzziagl",
  "block.minecraft.resin_clump": "Harzbrockn",
  "block.minecraft.respawn_anchor": "Seelenanka",
  "block.minecraft.rooted_dirt": "Wurzleade",
  "block.minecraft.rose_bush": "Rosnstrauch",
  "block.minecraft.sand": "Sond",
  "block.minecraft.sandstone": "Sondstoa",
  "block.minecraft.sandstone_slab": "Sandstoastufe",
  "block.minecraft.sandstone_stairs": "Sondstoaschdiang",
  "block.minecraft.sandstone_wall": "Sondstoamaua",
  "block.minecraft.scaffolding": "G'rüst",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk-Katalysator",
  "block.minecraft.sculk_sensor": "Sculk-Sensor",
  "block.minecraft.sculk_shrieker": "Sculk-Kreischer",
  "block.minecraft.sculk_vein": "Sculk-Ader",
  "block.minecraft.sea_lantern": "Seelaterne",
  "block.minecraft.sea_pickle": "Meeresgugumma",
  "block.minecraft.seagrass": "Seegras",
  "block.minecraft.set_spawn": "Wiedaoanstiegspunkt g'setzt",
  "block.minecraft.short_dry_grass": "Druckans Gros",
  "block.minecraft.short_grass": "Kurzs Gros",
  "block.minecraft.shroomlight": "Schwammalliacht",
  "block.minecraft.shulker_box": "Shulker-Kiste",
  "block.minecraft.skeleton_skull": "Skelettschädl",
  "block.minecraft.skeleton_wall_skull": "Skelett-Mauaschädl",
  "block.minecraft.slime_block": "Schleimblock",
  "block.minecraft.small_amethyst_bud": "Kleine Amethystknospe",
  "block.minecraft.small_dripleaf": "Kloanes Dropfbladl",
  "block.minecraft.smithing_table": "Schmieddisch",
  "block.minecraft.smoker": "Reichaofn",
  "block.minecraft.smooth_basalt": "Glatta Basalt",
  "block.minecraft.smooth_quartz": "Glatte Quarzblock",
  "block.minecraft.smooth_quartz_slab": "Glatte Quarzstufe",
  "block.minecraft.smooth_quartz_stairs": "Glatte Quarzschdiang",
  "block.minecraft.smooth_red_sandstone": "Glatte rouder Sondstoa",
  "block.minecraft.smooth_red_sandstone_slab": "Glatte roude Sondstoastufe",
  "block.minecraft.smooth_red_sandstone_stairs": "Glatte roude Sondstoaschdiang",
  "block.minecraft.smooth_sandstone": "Glatte Sondstoa",
  "block.minecraft.smooth_sandstone_slab": "Glatte Sondstoastufe",
  "block.minecraft.smooth_sandstone_stairs": "Glatte Sondstoaschdiang",
  "block.minecraft.smooth_stone": "Glatte Stoa",
  "block.minecraft.smooth_stone_slab": "Glatte Stoastufe",
  "block.minecraft.sniffer_egg": "Schniffer-Oa",
  "block.minecraft.snow": "Schnää",
  "block.minecraft.snow_block": "Schnääblock",
  "block.minecraft.soul_campfire": "Seelenlagafeia",
  "block.minecraft.soul_fire": "Seelenfeia",
  "block.minecraft.soul_lantern": "Seelenlaterne",
  "block.minecraft.soul_sand": "Seelensond",
  "block.minecraft.soul_soil": "Seelenerdn",
  "block.minecraft.soul_torch": "Seelenfackel",
  "block.minecraft.soul_wall_torch": "Seelenmauafackel",
  "block.minecraft.spawn.not_valid": "Du host koan Bett und koanen afg'ladnen Seelenanka, oda dei Wiedaoanstiegspunkt wurde blockiat",
  "block.minecraft.spawner": "Spawner",
  "block.minecraft.spawner.desc1": "Nutz Spawn-Oa:",
  "block.minecraft.spawner.desc2": "Setz Kreaturntyp",
  "block.minecraft.sponge": "Schwomm",
  "block.minecraft.spore_blossom": "Spornblüte",
  "block.minecraft.spruce_button": "Fichtnhoizknopf",
  "block.minecraft.spruce_door": "Fichtnhoiztia",
  "block.minecraft.spruce_fence": "Fichtnhoizzaun",
  "block.minecraft.spruce_fence_gate": "Fichtnhoizzauntor",
  "block.minecraft.spruce_hanging_sign": "Fichtnhoizhängadsschuidl",
  "block.minecraft.spruce_leaves": "Fichtnnadeln",
  "block.minecraft.spruce_log": "Fichtnstamm",
  "block.minecraft.spruce_planks": "Fitchnhoizbretta",
  "block.minecraft.spruce_pressure_plate": "Fichtnhoizdruckplatte",
  "block.minecraft.spruce_sapling": "Fichtnzweigerl",
  "block.minecraft.spruce_shelf": "Fichtnhoizreagl",
  "block.minecraft.spruce_sign": "Fichtnhoizschuid",
  "block.minecraft.spruce_slab": "Fichtnhoizstufe",
  "block.minecraft.spruce_stairs": "Fichtnhoizschdiang",
  "block.minecraft.spruce_trapdoor": "Fichtnhoizklappdierl",
  "block.minecraft.spruce_wall_hanging_sign": "Fichtnhoizwandhängadsschuidl",
  "block.minecraft.spruce_wall_sign": "Fichtnhoizmauaschuid",
  "block.minecraft.spruce_wood": "Fichtnhoiz",
  "block.minecraft.sticky_piston": "Klebriga Kolbn",
  "block.minecraft.stone": "Stoa",
  "block.minecraft.stone_brick_slab": "Stoaziegelstufe",
  "block.minecraft.stone_brick_stairs": "Stoazieglschdiang",
  "block.minecraft.stone_brick_wall": "Stoazieglmaua",
  "block.minecraft.stone_bricks": "Stoazigl",
  "block.minecraft.stone_button": "Stoaknopf",
  "block.minecraft.stone_pressure_plate": "Stoadruckplatte",
  "block.minecraft.stone_slab": "Stoastufe",
  "block.minecraft.stone_stairs": "Stoaschdiang",
  "block.minecraft.stonecutter": "Stoametz",
  "block.minecraft.stripped_acacia_log": "Entrindeter Akazienstamm",
  "block.minecraft.stripped_acacia_wood": "Entrindetes Akazienhoiz",
  "block.minecraft.stripped_bamboo_block": "G'schälta Bambusblock",
  "block.minecraft.stripped_birch_log": "Entrindeter Birknstamm",
  "block.minecraft.stripped_birch_wood": "Entrindetes Birknhoiz",
  "block.minecraft.stripped_cherry_log": "Entrindeter Kiaschstamm",
  "block.minecraft.stripped_cherry_wood": "Entrindetes Kiaschhoiz",
  "block.minecraft.stripped_crimson_hyphae": "Geschälta Karmesinhyphn",
  "block.minecraft.stripped_crimson_stem": "Geschälta Karmesinstil",
  "block.minecraft.stripped_dark_oak_log": "Entrindeter Schwoazoachenstamm",
  "block.minecraft.stripped_dark_oak_wood": "Entrindetes Schwoazoachenhoiz",
  "block.minecraft.stripped_jungle_log": "Entrindeter Tropnbaamstamm",
  "block.minecraft.stripped_jungle_wood": "Entrindetes Tropnhoiz",
  "block.minecraft.stripped_mangrove_log": "Entrindeta Mangrovenstomm",
  "block.minecraft.stripped_mangrove_wood": "Entrindets Mangrovenhoiz",
  "block.minecraft.stripped_oak_log": "Entrindeter Oachenstamm",
  "block.minecraft.stripped_oak_wood": "Entrindetes Oachenhoiz",
  "block.minecraft.stripped_pale_oak_log": "Heia Oachnhoizstamm",
  "block.minecraft.stripped_pale_oak_wood": "Entrindeter Heia Oachnhoizstamm",
  "block.minecraft.stripped_spruce_log": "Entrindeter Fichtnstamm",
  "block.minecraft.stripped_spruce_wood": "Entrindetes Fichtnhoiz",
  "block.minecraft.stripped_warped_hyphae": "Geschälta Wirrhyphn",
  "block.minecraft.stripped_warped_stem": "Geschälta Wirrstil",
  "block.minecraft.structure_block": "Konstruktionsblock",
  "block.minecraft.structure_void": "Konstruktionsleere",
  "block.minecraft.sugar_cane": "Zuggarohr",
  "block.minecraft.sunflower": "Sunnableame",
  "block.minecraft.suspicious_gravel": "Komischer Kies",
  "block.minecraft.suspicious_sand": "Komischer Sand",
  "block.minecraft.sweet_berry_bush": "Siaßbeernstrauch",
  "block.minecraft.tall_dry_grass": "Hohes druckans Gros",
  "block.minecraft.tall_grass": "Hohes Gras",
  "block.minecraft.tall_seagrass": "Hohes Seegras",
  "block.minecraft.target": "Zuiblock",
  "block.minecraft.terracotta": "Keramik",
  "block.minecraft.test_block": "Test Block",
  "block.minecraft.test_instance_block": "Testinstanzblock",
  "block.minecraft.tinted_glass": "Getöntes Glas",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT-Explosionen san ausgschoitn",
  "block.minecraft.torch": "Fackel",
  "block.minecraft.torchflower": "Fackelbleame",
  "block.minecraft.torchflower_crop": "Fackelbleamesamen",
  "block.minecraft.trapped_chest": "Redstone-Truhe",
  "block.minecraft.trial_spawner": "Prüfungs Spawner",
  "block.minecraft.tripwire": "Stoipadraht",
  "block.minecraft.tripwire_hook": "Hakn",
  "block.minecraft.tube_coral": "Käichkoralle",
  "block.minecraft.tube_coral_block": "Orgelkorallnblock",
  "block.minecraft.tube_coral_fan": "Orgelkorallnfächer",
  "block.minecraft.tube_coral_wall_fan": "Orgelkorallnwandfächa",
  "block.minecraft.tuff": "Tuffstoan",
  "block.minecraft.tuff_brick_slab": "Tuffziaglstufn",
  "block.minecraft.tuff_brick_stairs": "Tuffziaglstiagn",
  "block.minecraft.tuff_brick_wall": "Tuffziaglmauer",
  "block.minecraft.tuff_bricks": "Tuffziagl",
  "block.minecraft.tuff_slab": "Tuffstufn",
  "block.minecraft.tuff_stairs": "Tuffstiagn",
  "block.minecraft.tuff_wall": "Tuffmauer",
  "block.minecraft.turtle_egg": "Schuidkrötnoa",
  "block.minecraft.twisting_vines": "Zwirbelrankn",
  "block.minecraft.twisting_vines_plant": "Zwirbelranknpflanzna",
  "block.minecraft.vault": "Tresor",
  "block.minecraft.verdant_froglight": "Junggrüns Froschlicht",
  "block.minecraft.vine": "Rankn",
  "block.minecraft.void_air": "Leere Luft",
  "block.minecraft.wall_torch": "Mauafackel",
  "block.minecraft.warped_button": "Wirrknopf",
  "block.minecraft.warped_door": "Wirrtia",
  "block.minecraft.warped_fence": "Wirrzaun",
  "block.minecraft.warped_fence_gate": "Wirrzauntor",
  "block.minecraft.warped_fungus": "Wirrschwammal",
  "block.minecraft.warped_hanging_sign": "Wirrhoizhängadsschuidl",
  "block.minecraft.warped_hyphae": "Wirrhyphn",
  "block.minecraft.warped_nylium": "Wirr-Nezel",
  "block.minecraft.warped_planks": "Wirrbretta",
  "block.minecraft.warped_pressure_plate": "Wirrdruckplatte",
  "block.minecraft.warped_roots": "Wirrwuazn",
  "block.minecraft.warped_shelf": "Wirrhoizreagl",
  "block.minecraft.warped_sign": "Wirrschuid",
  "block.minecraft.warped_slab": "Wirrstufe",
  "block.minecraft.warped_stairs": "Wirrschdiang",
  "block.minecraft.warped_stem": "Wirrstil",
  "block.minecraft.warped_trapdoor": "Wirrklappdierl",
  "block.minecraft.warped_wall_hanging_sign": "Wirrhoizhängadsschuidl",
  "block.minecraft.warped_wall_sign": "Wirrmauaschuidl",
  "block.minecraft.warped_wart_block": "Wirrwarznblock",
  "block.minecraft.water": "Wossa",
  "block.minecraft.water_cauldron": "Wossakessl",
  "block.minecraft.waxed_chiseled_copper": "Gwachsta Gmeißelta Kupfablock",
  "block.minecraft.waxed_copper_bars": "Gwachsts Kupfagitter",
  "block.minecraft.waxed_copper_block": "G'wachsta Kupfablock",
  "block.minecraft.waxed_copper_bulb": "Gwachste Kupfalampn",
  "block.minecraft.waxed_copper_chain": "Gwachste Kupfakettn",
  "block.minecraft.waxed_copper_chest": "Gwachste Kupfakistn",
  "block.minecraft.waxed_copper_door": "Gwachste Kupfadia",
  "block.minecraft.waxed_copper_golem_statue": "Gwachste Kupfagolemstatü",
  "block.minecraft.waxed_copper_grate": "Gwachsts Kupfagitter",
  "block.minecraft.waxed_copper_lantern": "Gwachste Kupfalatarn",
  "block.minecraft.waxed_copper_trapdoor": "Gwachste Kupfaklappdierl",
  "block.minecraft.waxed_cut_copper": "G'wachsta geschnittena Kupfablock",
  "block.minecraft.waxed_cut_copper_slab": "G'wachste geschnittene Kupfastufe",
  "block.minecraft.waxed_cut_copper_stairs": "G'wachste geschnittene Kupfaschdiang",
  "block.minecraft.waxed_exposed_chiseled_copper": "Gwachsta Oglafana Gmeißelta Kupfablock",
  "block.minecraft.waxed_exposed_copper": "G'wachsta ang'laufena Kupfablock",
  "block.minecraft.waxed_exposed_copper_bars": "Gwachsts Aglaufenes Kupfagitter",
  "block.minecraft.waxed_exposed_copper_bulb": "Gwachste Oglafane Kupfalampn",
  "block.minecraft.waxed_exposed_copper_chain": "Gwachste Aglaufene Kupfakettn",
  "block.minecraft.waxed_exposed_copper_chest": "Gwachste Aglaufene Kupfakistn",
  "block.minecraft.waxed_exposed_copper_door": "Gwachste Oglafane Kupfadia",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Gwachste Aglaufene Kupfagolemstatue",
  "block.minecraft.waxed_exposed_copper_grate": "Gwachsts Oglafans Kupfagitter",
  "block.minecraft.waxed_exposed_copper_lantern": "Gwachste Aglaufene Kufpalatarn",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Gwachste Oglafane Kupfaklappdierl",
  "block.minecraft.waxed_exposed_cut_copper": "G'wachsta ang'laufena g'schnittena Kupfablock",
  "block.minecraft.waxed_exposed_cut_copper_slab": "G'wachste ang'laufene g'schnittene Kupfastufe",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "G'wachste ang'laufene g'schnittene Kupfatreppe",
  "block.minecraft.waxed_exposed_lightning_rod": "Gwachster Aglaufener Blitzobleida",
  "block.minecraft.waxed_lightning_rod": "Gwachster Blitzobleida",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Gwachsta Oxidierta Gmeißelta Kupfablock",
  "block.minecraft.waxed_oxidized_copper": "G'wachsta oxidiata Kupfablock",
  "block.minecraft.waxed_oxidized_copper_bars": "Gwachstes Oxidiats Kupfagitter",
  "block.minecraft.waxed_oxidized_copper_bulb": "Gwachste Oxidierte Kupfalampn",
  "block.minecraft.waxed_oxidized_copper_chain": "Gwachste Oxidiate Kupfakettn",
  "block.minecraft.waxed_oxidized_copper_chest": "Gwachste Oxidiate Kupfakistn",
  "block.minecraft.waxed_oxidized_copper_door": "Gwachste Oxidierte Kupfalampn",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Gwachste Oxidiate Kupfagolemstatue",
  "block.minecraft.waxed_oxidized_copper_grate": "Gwachsts Oxidierts Kupfagitter",
  "block.minecraft.waxed_oxidized_copper_lantern": "Gwachste Oxidiate Kupfalatarn",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Gwachste Oxidierte Kupfaklappdierl",
  "block.minecraft.waxed_oxidized_cut_copper": "G'wachsta oxidiata g'schnittena Kupfablock",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Gewachste oxidiate geschnittene Kupfastufe",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "G'wachste oxidiate g'schnittene Kupfaschdiang",
  "block.minecraft.waxed_oxidized_lightning_rod": "Gwachster Oxidiater Blitzobleida",
  "block.minecraft.waxed_weathered_chiseled_copper": "Gwachsta Verwitterta Gmeißelta Kupfablock",
  "block.minecraft.waxed_weathered_copper": "G'wachsta verwitterta Kupfablock",
  "block.minecraft.waxed_weathered_copper_bars": "Gwachsts Verwittats Kupfagitter",
  "block.minecraft.waxed_weathered_copper_bulb": "Gwachste Verwitterte Kupfalampn",
  "block.minecraft.waxed_weathered_copper_chain": "Gwachste Verwittate Kupfakettn",
  "block.minecraft.waxed_weathered_copper_chest": "Gwachste Verwittate Kupfakistn",
  "block.minecraft.waxed_weathered_copper_door": "Gwachste Verwitterte Kupfadia",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Gwachste Verwittate Kupfagolemstatue",
  "block.minecraft.waxed_weathered_copper_grate": "Gwachsts Verwitterts Kupfagitter",
  "block.minecraft.waxed_weathered_copper_lantern": "Gwachste Verwittate Kupfalatarn",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Gwachsts Verwitterts Kupfaklappdierl",
  "block.minecraft.waxed_weathered_cut_copper": "G'wachsta verwitterta g'schnittena Kupfablock",
  "block.minecraft.waxed_weathered_cut_copper_slab": "G'wachste verwitterte g'schnittene Kupfastufe",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "G'wachste verwitterte g'schnittene Kupfatreppe",
  "block.minecraft.waxed_weathered_lightning_rod": "Gwachster Verwittater Blitzobleida",
  "block.minecraft.weathered_chiseled_copper": "Verwitterta Gmeißelta Kupfablock",
  "block.minecraft.weathered_copper": "Verwitterta Kupfablock",
  "block.minecraft.weathered_copper_bars": "Verwittats Kupfagitter",
  "block.minecraft.weathered_copper_bulb": "Verwitterte Kupfalampn",
  "block.minecraft.weathered_copper_chain": "Verwittate Kupfakettn",
  "block.minecraft.weathered_copper_chest": "Verwittate Kupferkistn",
  "block.minecraft.weathered_copper_door": "Verwittate Kupfadia",
  "block.minecraft.weathered_copper_golem_statue": "Verwittate Kupfagolemstatü",
  "block.minecraft.weathered_copper_grate": "Verwittats Kupfagitter",
  "block.minecraft.weathered_copper_lantern": "Verwittate Kupfalatarn",
  "block.minecraft.weathered_copper_trapdoor": "Verwittats Kupfaklappdierl",
  "block.minecraft.weathered_cut_copper": "Verwitterta geschnittena Kupfablock",
  "block.minecraft.weathered_cut_copper_slab": "Verwitterte geschnittene Kupfastufe",
  "block.minecraft.weathered_cut_copper_stairs": "Verwitterte geschnittene Kupfaschdiang",
  "block.minecraft.weathered_lightning_rod": "Verwittater Blitzobleida",
  "block.minecraft.weeping_vines": "Trauarankn",
  "block.minecraft.weeping_vines_plant": "Trauaranknpflanzna",
  "block.minecraft.wet_sponge": "Nossa Schwomm",
  "block.minecraft.wheat": "Woaznpflanzn",
  "block.minecraft.white_banner": "Weissa Banner",
  "block.minecraft.white_bed": "Weißes Bett",
  "block.minecraft.white_candle": "Weiße Keaze",
  "block.minecraft.white_candle_cake": "Kuachn mid weißa Keaze",
  "block.minecraft.white_carpet": "Weißa Teppich",
  "block.minecraft.white_concrete": "Weißa Bedau",
  "block.minecraft.white_concrete_powder": "Weißa Trocknbeton",
  "block.minecraft.white_glazed_terracotta": "Weiße glasierde Keramik",
  "block.minecraft.white_shulker_box": "Weiße Shulker-Kiste",
  "block.minecraft.white_stained_glass": "Weißes Glas",
  "block.minecraft.white_stained_glass_pane": "Weiße Glasscheibe",
  "block.minecraft.white_terracotta": "Weiße Keramik",
  "block.minecraft.white_tulip": "Weiße Tulpe",
  "block.minecraft.white_wool": "Weiße Wolle",
  "block.minecraft.wildflowers": "Wuide Bleamal",
  "block.minecraft.wither_rose": "Witherrosn",
  "block.minecraft.wither_skeleton_skull": "Witherskelettschädl",
  "block.minecraft.wither_skeleton_wall_skull": "Witherskelettmauaschädl",
  "block.minecraft.yellow_banner": "Gelba Banner",
  "block.minecraft.yellow_bed": "Gäibs Bett",
  "block.minecraft.yellow_candle": "Gejbe Keaze",
  "block.minecraft.yellow_candle_cake": "Kuachn mid gejba Keaze",
  "block.minecraft.yellow_carpet": "Gejba Teppich",
  "block.minecraft.yellow_concrete": "Gejba Bedau",
  "block.minecraft.yellow_concrete_powder": "Gejba Trocknbedau",
  "block.minecraft.yellow_glazed_terracotta": "Gejbe glasierte Keramik",
  "block.minecraft.yellow_shulker_box": "Gejbe Shulker-Kiste",
  "block.minecraft.yellow_stained_glass": "Gejbs Glas",
  "block.minecraft.yellow_stained_glass_pane": "Gejbe Glasscheibe",
  "block.minecraft.yellow_terracotta": "Gejbs Keramik",
  "block.minecraft.yellow_wool": "Gejbe Wolle",
  "block.minecraft.zombie_head": "Zombieschädl",
  "block.minecraft.zombie_wall_head": "Zombie-Mauaschädl",
  "item.minecraft.acacia_boat": "Akazienhoizboot",
  "item.minecraft.acacia_chest_boat": "Akazienhoiztruhenboot",
  "item.minecraft.allay_spawn_egg": "Huifsgoast-Spawn-Oa",
  "item.minecraft.amethyst_shard": "Amethystscherbe",
  "item.minecraft.angler_pottery_shard": "Angler-Töpferscherm",
  "item.minecraft.angler_pottery_sherd": "Angler-Töpferscherm",
  "item.minecraft.apple": "Opfe",
  "item.minecraft.archer_pottery_shard": "Schützen-Töpferscherm",
  "item.minecraft.archer_pottery_sherd": "Schützen-Töpferscherm",
  "item.minecraft.armadillo_scute": "Gürtltierschuppn",
  "item.minecraft.armadillo_spawn_egg": "Gürtltier Spawn-Ei",
  "item.minecraft.armor_stand": "Rüstungsstända",
  "item.minecraft.arms_up_pottery_shard": "Gfuchtl-Töpferscherm",
  "item.minecraft.arms_up_pottery_sherd": "Gfuchtl-Töpferscherm",
  "item.minecraft.arrow": "Pfeil",
  "item.minecraft.axolotl_bucket": "Axolotloama",
  "item.minecraft.axolotl_spawn_egg": "Axolotl-Spawn-Oa",
  "item.minecraft.baked_potato": "Backne Kadoffe",
  "item.minecraft.bamboo_chest_raft": "Bambushoiztruhenfloß",
  "item.minecraft.bamboo_raft": "Bambusfloß",
  "item.minecraft.bat_spawn_egg": "Fledermaus-Spawn-Oa",
  "item.minecraft.bee_spawn_egg": "Impn-Spawn-Oa",
  "item.minecraft.beef": "Rohs Rind",
  "item.minecraft.beetroot": "Ranna",
  "item.minecraft.beetroot_seeds": "Rannakerndl",
  "item.minecraft.beetroot_soup": "Borschtsch",
  "item.minecraft.birch_boat": "Birknhoizboot",
  "item.minecraft.birch_chest_boat": "Birknhoiztruhenboot",
  "item.minecraft.black_bundle": "Schwoaz Bündel",
  "item.minecraft.black_dye": "Schwoaza Foabstoff",
  "item.minecraft.black_harness": "Schwarzes Gschirr",
  "item.minecraft.blade_pottery_shard": "Klingen-Töpferscherm",
  "item.minecraft.blade_pottery_sherd": "Klingen-Töpferscherm",
  "item.minecraft.blaze_powder": "Artikel.minecraft.Flammenpuder",
  "item.minecraft.blaze_rod": "Lohenrute",
  "item.minecraft.blaze_spawn_egg": "Lohe-Spawn-Oa",
  "item.minecraft.blue_bundle": "Blaues Bündel",
  "item.minecraft.blue_dye": "Blaua Foabstoff",
  "item.minecraft.blue_egg": "Blaus Ei",
  "item.minecraft.blue_harness": "Blaus Gschirr",
  "item.minecraft.bogged_spawn_egg": "Moorleichn Spawn-Ei",
  "item.minecraft.bolt_armor_trim_smithing_template": "Schmiedevorlang",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Boizn-Rüstungsschmuck",
  "item.minecraft.bone": "Boanen",
  "item.minecraft.bone_meal": "Boanenmej",
  "item.minecraft.book": "Buach",
  "item.minecraft.bordure_indented_banner_pattern": "Bordürenbannervorlag",
  "item.minecraft.bow": "Boong",
  "item.minecraft.bowl": "Schüssl",
  "item.minecraft.bread": "Brod",
  "item.minecraft.breeze_rod": "Brisnsteckerl",
  "item.minecraft.breeze_spawn_egg": "Brisn Spawn-Ei",
  "item.minecraft.brewer_pottery_shard": "Brauer-Töperscherm",
  "item.minecraft.brewer_pottery_sherd": "Brauer-Töperscherm",
  "item.minecraft.brewing_stand": "Brauerei",
  "item.minecraft.brick": "Ziegl",
  "item.minecraft.brown_bundle": "Brauns Bündel",
  "item.minecraft.brown_dye": "Brauna Foabstoff",
  "item.minecraft.brown_egg": "Brauns Ei",
  "item.minecraft.brown_harness": "Brauns Gschirr",
  "item.minecraft.brush": "Waschl",
  "item.minecraft.bucket": "Oama",
  "item.minecraft.bundle": "Bündl",
  "item.minecraft.bundle.empty": "Lar",
  "item.minecraft.bundle.empty.description": "Ko an gmischtn Stack Items hoitn",
  "item.minecraft.bundle.full": "Voi",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Feier-Töpferscherm",
  "item.minecraft.burn_pottery_sherd": "Feier-Töpferscherm",
  "item.minecraft.camel_husk_spawn_egg": "Oa vom Zombiedromedar",
  "item.minecraft.camel_spawn_egg": "Dromedar Spawn Ei",
  "item.minecraft.carrot": "Gejbe Ruam",
  "item.minecraft.carrot_on_a_stick": "Karottn om Stock",
  "item.minecraft.cat_spawn_egg": "Kotz-Spawn-Oa",
  "item.minecraft.cauldron": "Kessl",
  "item.minecraft.cave_spider_spawn_egg": "Höin Spinna-Spawn-Oa",
  "item.minecraft.chainmail_boots": "Kettnsocka",
  "item.minecraft.chainmail_chestplate": "Kettnhemat",
  "item.minecraft.chainmail_helmet": "Kettenmützn",
  "item.minecraft.chainmail_leggings": "Kettnhosn",
  "item.minecraft.charcoal": "Hoizkuin",
  "item.minecraft.cherry_boat": "Kiaschhoizboot",
  "item.minecraft.cherry_chest_boat": "Kiaschhoiztruhenboot",
  "item.minecraft.chest_minecart": "Gütalore",
  "item.minecraft.chicken": "Rohs Händl",
  "item.minecraft.chicken_spawn_egg": "Huhn-Spawn-Oa",
  "item.minecraft.chorus_fruit": "Chorusfrucht",
  "item.minecraft.clay_ball": "Tonklumpn",
  "item.minecraft.clock": "Uah",
  "item.minecraft.coal": "Kuin",
  "item.minecraft.coast_armor_trim_smithing_template": "Schmiedevorlang",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Küstn-Rüstungsschmuck",
  "item.minecraft.cocoa_beans": "Kakaobohna",
  "item.minecraft.cod": "Rohs Kabeljau",
  "item.minecraft.cod_bucket": "Kabeljauoima",
  "item.minecraft.cod_spawn_egg": "Kabeljau-Spawn-Oa",
  "item.minecraft.command_block_minecart": "Befehlsblocklore",
  "item.minecraft.compass": "Kompass",
  "item.minecraft.cooked_beef": "Steak",
  "item.minecraft.cooked_chicken": "Brathändl",
  "item.minecraft.cooked_cod": "Gebranter Kabeljau",
  "item.minecraft.cooked_mutton": "Lammkoteletts",
  "item.minecraft.cooked_porkchop": "Schweinsbratn",
  "item.minecraft.cooked_rabbit": "Bratner Haas",
  "item.minecraft.cooked_salmon": "Gebranter Lachs",
  "item.minecraft.cookie": "Keks",
  "item.minecraft.copper_axe": "Kupfaoxt",
  "item.minecraft.copper_boots": "Kupferschuah",
  "item.minecraft.copper_chestplate": "Kupferbrustplatt’n",
  "item.minecraft.copper_golem_spawn_egg": "Oa vom Kupfagolem",
  "item.minecraft.copper_helmet": "Kupfahölm",
  "item.minecraft.copper_hoe": "Kupfahack'n",
  "item.minecraft.copper_horse_armor": "Kupfa-Pferdepanza",
  "item.minecraft.copper_ingot": "Kupfabarrn",
  "item.minecraft.copper_leggings": "Kupfahos'n",
  "item.minecraft.copper_nautilus_armor": "Kupfa­-Nautiluspanza",
  "item.minecraft.copper_nugget": "Kupfaklumpn",
  "item.minecraft.copper_pickaxe": "Kupfaspitzhackn",
  "item.minecraft.copper_shovel": "Kupfaschaufl",
  "item.minecraft.copper_spear": "Kupfaspiaß",
  "item.minecraft.copper_sword": "Kupfaschwert",
  "item.minecraft.cow_spawn_egg": "Rindvieh-Spawn-Oa",
  "item.minecraft.creaking_spawn_egg": "Kracha-Spawnei",
  "item.minecraft.creeper_banner_pattern": "Bannervorlage",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Creeper-Bannervorlag",
  "item.minecraft.creeper_spawn_egg": "Creeper-Spawn-Oa",
  "item.minecraft.crossbow": "Oambrust",
  "item.minecraft.crossbow.projectile": "Gschoß:",
  "item.minecraft.crossbow.projectile.multiple": "Projektil: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projektil: %s",
  "item.minecraft.cyan_bundle": "Türkises Bündl",
  "item.minecraft.cyan_dye": "Türkisa Foabstoff",
  "item.minecraft.cyan_harness": "Türkises Gschirr",
  "item.minecraft.danger_pottery_shard": "Gfahr-Töpferscherm",
  "item.minecraft.danger_pottery_sherd": "Gfahr-Töpferscherm",
  "item.minecraft.dark_oak_boat": "Schwoazoachenhoizboot",
  "item.minecraft.dark_oak_chest_boat": "Schwoazeichntruhenboot",
  "item.minecraft.debug_stick": "Debug-Stock",
  "item.minecraft.debug_stick.empty": "%s hotkoane Eignschoftn",
  "item.minecraft.debug_stick.select": "\"%s\" asg'wäid (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" zu %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamanthogg",
  "item.minecraft.diamond_boots": "Diamantschuah",
  "item.minecraft.diamond_chestplate": "Diamantharnisch",
  "item.minecraft.diamond_helmet": "Diamanthelm",
  "item.minecraft.diamond_hoe": "Diamanthau",
  "item.minecraft.diamond_horse_armor": "Diamantena Roßharnisch",
  "item.minecraft.diamond_leggings": "Diamanthaxnschutz",
  "item.minecraft.diamond_nautilus_armor": "Diamant-Nautiluspanza",
  "item.minecraft.diamond_pickaxe": "Diamantgrompm",
  "item.minecraft.diamond_shovel": "Diamantschaufl",
  "item.minecraft.diamond_spear": "Diamantspiaß",
  "item.minecraft.diamond_sword": "Diamantschwert",
  "item.minecraft.disc_fragment_5": "Plattnstickl",
  "item.minecraft.disc_fragment_5.desc": "Schallplattn - 5",
  "item.minecraft.dolphin_spawn_egg": "Delfin-Spawn-Oa",
  "item.minecraft.donkey_spawn_egg": "Esel-Spawn-Oa",
  "item.minecraft.dragon_breath": "Drachnatem",
  "item.minecraft.dried_kelp": "Getrockneter Seetang",
  "item.minecraft.drowned_spawn_egg": "Ertrunkener-Spawn-Oa",
  "item.minecraft.dune_armor_trim_smithing_template": "Schmiedevorlang",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dünen-Rüstungsschmuck",
  "item.minecraft.echo_shard": "Echo Scherm",
  "item.minecraft.egg": "Oa",
  "item.minecraft.elder_guardian_spawn_egg": "Großer Wächter-Spawn-Oa",
  "item.minecraft.elytra": "Elytren",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Zaubabuach",
  "item.minecraft.enchanted_golden_apple": "Verzauberter goldener Apfel",
  "item.minecraft.end_crystal": "Enderkrisdoj",
  "item.minecraft.ender_dragon_spawn_egg": "Enderdroche-Spawn-Oa",
  "item.minecraft.ender_eye": "Enderaug",
  "item.minecraft.ender_pearl": "Enderperle",
  "item.minecraft.enderman_spawn_egg": "Enderman-Spawn-Oa",
  "item.minecraft.endermite_spawn_egg": "Endermite-Spawn-Oa",
  "item.minecraft.evoker_spawn_egg": "Magier-Spawn-Oa",
  "item.minecraft.experience_bottle": "Zauberflaschl",
  "item.minecraft.explorer_pottery_shard": "Entdecker-Töpferscherm",
  "item.minecraft.explorer_pottery_sherd": "Entdecker-Töpferscherm",
  "item.minecraft.eye_armor_trim_smithing_template": "Schmiedevorlang",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Augn-Rüstungsschmuck",
  "item.minecraft.feather": "Feda",
  "item.minecraft.fermented_spider_eye": "Fermentiertes Spinnaauge",
  "item.minecraft.field_masoned_banner_pattern": "Gmeia-Bannerschmuck",
  "item.minecraft.filled_map": "Koate",
  "item.minecraft.fire_charge": "Feierboi",
  "item.minecraft.firework_rocket": "Feierwerksraketn",
  "item.minecraft.firework_rocket.flight": "Dauer vom Fliang:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Feierwerksstern",
  "item.minecraft.firework_star.black": "Schwoaz",
  "item.minecraft.firework_star.blue": "Blau",
  "item.minecraft.firework_star.brown": "Braun",
  "item.minecraft.firework_star.custom_color": "Benutzadefiniat",
  "item.minecraft.firework_star.cyan": "Türkis",
  "item.minecraft.firework_star.fade_to": "Übagang zu",
  "item.minecraft.firework_star.flicker": "Funkeln",
  "item.minecraft.firework_star.gray": "Grau",
  "item.minecraft.firework_star.green": "Grean",
  "item.minecraft.firework_star.light_blue": "Höiblau",
  "item.minecraft.firework_star.light_gray": "Höigrau",
  "item.minecraft.firework_star.lime": "Giftgrea",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Orange",
  "item.minecraft.firework_star.pink": "Rosa",
  "item.minecraft.firework_star.purple": "Violett",
  "item.minecraft.firework_star.red": "Roud",
  "item.minecraft.firework_star.shape": "Unbekonnte Form",
  "item.minecraft.firework_star.shape.burst": "Explosion",
  "item.minecraft.firework_star.shape.creeper": "Creeperförmig",
  "item.minecraft.firework_star.shape.large_ball": "Große Kugl",
  "item.minecraft.firework_star.shape.small_ball": "Kleine Kugl",
  "item.minecraft.firework_star.shape.star": "Steanförmig",
  "item.minecraft.firework_star.trail": "Schwoaf",
  "item.minecraft.firework_star.white": "Weiß",
  "item.minecraft.firework_star.yellow": "Gejb",
  "item.minecraft.fishing_rod": "Angel",
  "item.minecraft.flint": "Feiastoa",
  "item.minecraft.flint_and_steel": "Feiazeig",
  "item.minecraft.flow_armor_trim_smithing_template": "Schmiedevorlang",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Fluss-Rüstungsschmuck",
  "item.minecraft.flow_banner_pattern": "Bannervorlang",
  "item.minecraft.flow_banner_pattern.desc": "Ache",
  "item.minecraft.flow_banner_pattern.new": "Fluss-Bannervorlag",
  "item.minecraft.flow_pottery_sherd": "Fluss-Töpferscherm",
  "item.minecraft.flower_banner_pattern": "Bannervorlagn",
  "item.minecraft.flower_banner_pattern.desc": "Bläamen",
  "item.minecraft.flower_banner_pattern.new": "Bleame-Bannervorlag",
  "item.minecraft.flower_pot": "Blummatopf",
  "item.minecraft.fox_spawn_egg": "Fuchs-Spawn-Oa",
  "item.minecraft.friend_pottery_shard": "Freind-Töoferscherm",
  "item.minecraft.friend_pottery_sherd": "Freind-Töpferscherm",
  "item.minecraft.frog_spawn_egg": "Frosch-Spawn-Oa",
  "item.minecraft.furnace_minecart": "Ontriebslore",
  "item.minecraft.ghast_spawn_egg": "Ghast-Spawn-Oa",
  "item.minecraft.ghast_tear": "Ghastträne",
  "item.minecraft.glass_bottle": "Glosflaschn",
  "item.minecraft.glistering_melon_slice": "Glitzande Melonenscheibe",
  "item.minecraft.globe_banner_pattern": "Bannervorlagn",
  "item.minecraft.globe_banner_pattern.desc": "Globus",
  "item.minecraft.globe_banner_pattern.new": "Globus-Bannervorlag",
  "item.minecraft.glow_berries": "Leichtbean",
  "item.minecraft.glow_ink_sac": "Leichttintnbeitl",
  "item.minecraft.glow_item_frame": "Leichtrahmen",
  "item.minecraft.glow_squid_spawn_egg": "Leichttintnfiisch-Spawn-Oa",
  "item.minecraft.glowstone_dust": "Leichtstoalurch",
  "item.minecraft.goat_horn": "Goaßherndl",
  "item.minecraft.goat_spawn_egg": "Goaßn-Spawn-Oa",
  "item.minecraft.gold_ingot": "Goidbarren",
  "item.minecraft.gold_nugget": "Goidklumpn",
  "item.minecraft.golden_apple": "Goidener Opfe",
  "item.minecraft.golden_axe": "Goidhogg",
  "item.minecraft.golden_boots": "Goidschuah",
  "item.minecraft.golden_carrot": "Goidene Ruam",
  "item.minecraft.golden_chestplate": "Goidharnisch",
  "item.minecraft.golden_helmet": "Goidhelm",
  "item.minecraft.golden_hoe": "Goidhau",
  "item.minecraft.golden_horse_armor": "Goidena Roßharnisch",
  "item.minecraft.golden_leggings": "Goidhaxnschutz",
  "item.minecraft.golden_nautilus_armor": "Goid-Nautiluspanza",
  "item.minecraft.golden_pickaxe": "Goidgrompm",
  "item.minecraft.golden_shovel": "Goidschaufl",
  "item.minecraft.golden_spear": "Goidspiaß",
  "item.minecraft.golden_sword": "Goidschwert",
  "item.minecraft.gray_bundle": "Graus Bündel",
  "item.minecraft.gray_dye": "Graua Foabstoff",
  "item.minecraft.gray_harness": "Graus Gschirr",
  "item.minecraft.green_bundle": "Greans Bündel",
  "item.minecraft.green_dye": "Greana Foabstoff",
  "item.minecraft.green_harness": "Greans Gschirr",
  "item.minecraft.guardian_spawn_egg": "Wächter-Spawn-Oa",
  "item.minecraft.gunpowder": "Schwoazpulva",
  "item.minecraft.guster_banner_pattern": "Bannervorlang",
  "item.minecraft.guster_banner_pattern.desc": "Bloser",
  "item.minecraft.guster_banner_pattern.new": "Liftl-Bannervorlag",
  "item.minecraft.guster_pottery_sherd": "Bloser-Töpferscherm",
  "item.minecraft.happy_ghast_spawn_egg": "Lachada Ghast Spawn-Ei",
  "item.minecraft.harness": "Gschirr",
  "item.minecraft.heart_of_the_sea": "Meerherz",
  "item.minecraft.heart_pottery_shard": "Herz-Töpferscherm",
  "item.minecraft.heart_pottery_sherd": "Herz-Töpferscherm",
  "item.minecraft.heartbreak_pottery_shard": "Herzweh-Töpferscheim",
  "item.minecraft.heartbreak_pottery_sherd": "Herzweh-Töpferscheim",
  "item.minecraft.hoglin_spawn_egg": "Hoglin-Spawn-Oa",
  "item.minecraft.honey_bottle": "Honiflasche",
  "item.minecraft.honeycomb": "Honiwabe",
  "item.minecraft.hopper_minecart": "Trichtalore",
  "item.minecraft.horse_spawn_egg": "Roß-Spawn-Oa",
  "item.minecraft.host_armor_trim_smithing_template": "Schmiedevorlang",
  "item.minecraft.host_armor_trim_smithing_template.new": "Wirts-Rüstungsschmuck",
  "item.minecraft.howl_pottery_shard": "Gheul-Töpferscherm",
  "item.minecraft.howl_pottery_sherd": "Gheul-Töpferscherm",
  "item.minecraft.husk_spawn_egg": "Wiastnzombie-Spawn-Oa",
  "item.minecraft.ink_sac": "Tintnbeitl",
  "item.minecraft.iron_axe": "Eisenhogg",
  "item.minecraft.iron_boots": "Eisenschuah",
  "item.minecraft.iron_chestplate": "Eisenharnisch",
  "item.minecraft.iron_golem_spawn_egg": "Eisngolem-Spawn-Ei",
  "item.minecraft.iron_helmet": "Eisenhelm",
  "item.minecraft.iron_hoe": "Eisenhau",
  "item.minecraft.iron_horse_armor": "Eiserna Roßharnisch",
  "item.minecraft.iron_ingot": "Eisenbarren",
  "item.minecraft.iron_leggings": "Eisenhaxnschutz",
  "item.minecraft.iron_nautilus_armor": "Eisn-Nautiluspanza",
  "item.minecraft.iron_nugget": "Eisenklumpn",
  "item.minecraft.iron_pickaxe": "Eisengrompm",
  "item.minecraft.iron_shovel": "Eisenschaufl",
  "item.minecraft.iron_spear": "Eisnspiaß",
  "item.minecraft.iron_sword": "Eisenschwert",
  "item.minecraft.item_frame": "Rahm’",
  "item.minecraft.jungle_boat": "Tropnhoizboot",
  "item.minecraft.jungle_chest_boat": "Tropnhoiztruhenboot",
  "item.minecraft.knowledge_book": "Buach des Wissens",
  "item.minecraft.lapis_lazuli": "Lapislazuli",
  "item.minecraft.lava_bucket": "Lavaoima",
  "item.minecraft.lead": "Leine",
  "item.minecraft.leather": "Leda",
  "item.minecraft.leather_boots": "Lederschuah",
  "item.minecraft.leather_chestplate": "Ledajanka",
  "item.minecraft.leather_helmet": "Ledermützn",
  "item.minecraft.leather_horse_armor": "Ledana Roßharnisch",
  "item.minecraft.leather_leggings": "Ledahosn",
  "item.minecraft.light_blue_bundle": "Heiblaus Bündel",
  "item.minecraft.light_blue_dye": "Höiblaue Farb",
  "item.minecraft.light_blue_harness": "Heiblaus Gschirr",
  "item.minecraft.light_gray_bundle": "Heigraus Bündel",
  "item.minecraft.light_gray_dye": "Höigraue Farb",
  "item.minecraft.light_gray_harness": "Heigraus Gschirr",
  "item.minecraft.lime_bundle": "Heigreans Bündel",
  "item.minecraft.lime_dye": "Giftgreana Foabstoff",
  "item.minecraft.lime_harness": "Heigreans Gschirr",
  "item.minecraft.lingering_potion": "Verweilender Trank",
  "item.minecraft.lingering_potion.effect.awkward": "Seltsamer Verweiltrank",
  "item.minecraft.lingering_potion.effect.empty": "Nicht braubara Verweiltrank",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Verweiltrank da Feuerresistenz",
  "item.minecraft.lingering_potion.effect.harming": "Verweiltrank des Schadens",
  "item.minecraft.lingering_potion.effect.healing": "Verweiltrank da Heilung",
  "item.minecraft.lingering_potion.effect.infested": "Vaweiltrank des Befalls",
  "item.minecraft.lingering_potion.effect.invisibility": "Verweiltrank da Unsichtbarkeit",
  "item.minecraft.lingering_potion.effect.leaping": "Verweiltrank da Sprungkraft",
  "item.minecraft.lingering_potion.effect.levitation": "Verweiltrank da Schwebekraft",
  "item.minecraft.lingering_potion.effect.luck": "Verweiltrank des Glücks",
  "item.minecraft.lingering_potion.effect.mundane": "Gewöhnlicha Verweiltrank",
  "item.minecraft.lingering_potion.effect.night_vision": "Verweiltrank da Nachtsicht",
  "item.minecraft.lingering_potion.effect.oozing": "Vaweiktrank des Rotzens",
  "item.minecraft.lingering_potion.effect.poison": "Verweiltrank da Vergiftung",
  "item.minecraft.lingering_potion.effect.regeneration": "Verweiltrank da Regeneration",
  "item.minecraft.lingering_potion.effect.slow_falling": "Verweiltrank des sanften Falls",
  "item.minecraft.lingering_potion.effect.slowness": "Verweiltrank da Langsamkeit",
  "item.minecraft.lingering_potion.effect.strength": "Verweiltrank da Stärke",
  "item.minecraft.lingering_potion.effect.swiftness": "Verweiltrank da Schnelligkeit",
  "item.minecraft.lingering_potion.effect.thick": "Dickflüssiger Verweiltrank",
  "item.minecraft.lingering_potion.effect.turtle_master": "Verweiltrank des Schildkrötenmeisters",
  "item.minecraft.lingering_potion.effect.water": "Verweilende Wossaflasche",
  "item.minecraft.lingering_potion.effect.water_breathing": "Verweiltrank da Unterwossaatmung",
  "item.minecraft.lingering_potion.effect.weakness": "Verweiltrank da Schwäche",
  "item.minecraft.lingering_potion.effect.weaving": "Vaweiltrank da Spinnerei",
  "item.minecraft.lingering_potion.effect.wind_charged": "Vaweiktrank des Lifterls",
  "item.minecraft.llama_spawn_egg": "Lama-Spawn-Oa",
  "item.minecraft.lodestone_compass": "Leitstoa-Kompass",
  "item.minecraft.mace": "Streitkoim",
  "item.minecraft.magenta_bundle": "Magenta Bündel",
  "item.minecraft.magenta_dye": "Magenta Farb",
  "item.minecraft.magenta_harness": "Pinks Gschirr",
  "item.minecraft.magma_cream": "Magmacreme",
  "item.minecraft.magma_cube_spawn_egg": "Magmawürfel-Spawn-Oa",
  "item.minecraft.mangrove_boat": "Mangrovnhoizboot",
  "item.minecraft.mangrove_chest_boat": "Mangrovnhoiztruhenboot",
  "item.minecraft.map": "Leere Koate",
  "item.minecraft.melon_seeds": "Melonakerndl",
  "item.minecraft.melon_slice": "Stickl Melona",
  "item.minecraft.milk_bucket": "Muichoima",
  "item.minecraft.minecart": "Lore",
  "item.minecraft.miner_pottery_shard": "Bergarbeiter-Töpferscherm",
  "item.minecraft.miner_pottery_sherd": "Bergarbeiter-Töpferscherm",
  "item.minecraft.mojang_banner_pattern": "Bannervorlagn",
  "item.minecraft.mojang_banner_pattern.desc": "Mojang-Logo",
  "item.minecraft.mojang_banner_pattern.new": "Dings-Bannervorlag",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom-Spawn-Oa",
  "item.minecraft.mourner_pottery_shard": "Trauernder-Töpferscherm",
  "item.minecraft.mourner_pottery_sherd": "Trauernder-Töpferscherm",
  "item.minecraft.mule_spawn_egg": "Maultier-Spawn-Oa",
  "item.minecraft.mushroom_stew": "Schwammal Suppn",
  "item.minecraft.music_disc_11": "Schoiplattn",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Schoiplattn",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Schoiplattn",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Schoiplattn",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Schoiplattn",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Schoiplattn",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Schoiplattn",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Schoiplattn",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Spieluhr)",
  "item.minecraft.music_disc_far": "Schoiplattn",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Schallplattn",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Schoiplattn",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Schoiplattn",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Schoiplattn",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Schoiplattn",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Schoiplattn",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Schoiplattn",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Schoiplattn",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Schoiplattn",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Schallplattn",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Schoiplattn",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Schoiplattn",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Rohs Lamm",
  "item.minecraft.name_tag": "Namansschuid",
  "item.minecraft.nautilus_shell": "Schnecknheiserl",
  "item.minecraft.nautilus_spawn_egg": "Nautilus-Spawn-Oa",
  "item.minecraft.nether_brick": "Netherziegl",
  "item.minecraft.nether_star": "Netherstern",
  "item.minecraft.nether_wart": "Netherwarzn",
  "item.minecraft.netherite_axe": "Netherithogg",
  "item.minecraft.netherite_boots": "Netheritschuah",
  "item.minecraft.netherite_chestplate": "Netheritbrustplattn",
  "item.minecraft.netherite_helmet": "Netherithelm",
  "item.minecraft.netherite_hoe": "Netherithakn",
  "item.minecraft.netherite_horse_armor": "Netherit-Pferdepanza",
  "item.minecraft.netherite_ingot": "Netheritbarren",
  "item.minecraft.netherite_leggings": "Netherithaxnschutz",
  "item.minecraft.netherite_nautilus_armor": "Netherit-Nautiluspanza",
  "item.minecraft.netherite_pickaxe": "Netheritgrompm",
  "item.minecraft.netherite_scrap": "Netheritbrockn",
  "item.minecraft.netherite_shovel": "Netheritschaufl",
  "item.minecraft.netherite_spear": "Netheritspiaß",
  "item.minecraft.netherite_sword": "Netheritschwert",
  "item.minecraft.netherite_upgrade_smithing_template": "Schmiedevorlang",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Upgrade",
  "item.minecraft.oak_boat": "Oachenhoizboot",
  "item.minecraft.oak_chest_boat": "Oachnhoiztruhenboot",
  "item.minecraft.ocelot_spawn_egg": "Wuidkotz-Spawn-Oa",
  "item.minecraft.ominous_bottle": "Ominöse Flaschn",
  "item.minecraft.ominous_trial_key": "Ominösa Priafungsschlissl",
  "item.minecraft.orange_bundle": "Orangs Bündel",
  "item.minecraft.orange_dye": "Oranga Foabstoff",
  "item.minecraft.orange_harness": "Orangs Gschirr",
  "item.minecraft.painting": "Gemälde",
  "item.minecraft.pale_oak_boat": "Heis Oachnboot",
  "item.minecraft.pale_oak_chest_boat": "Heis Oachntruhenboot",
  "item.minecraft.panda_spawn_egg": "Panda-Spawn-Oa",
  "item.minecraft.paper": "Papier",
  "item.minecraft.parched_spawn_egg": "Vertrocknata-Spawn-Oa",
  "item.minecraft.parrot_spawn_egg": "Papagei-Spawn-Oa",
  "item.minecraft.phantom_membrane": "Phantommembran",
  "item.minecraft.phantom_spawn_egg": "Phantom-Spawn-Oa",
  "item.minecraft.pig_spawn_egg": "Sei-Spawn-Oa",
  "item.minecraft.piglin_banner_pattern": "Bannervorlagn",
  "item.minecraft.piglin_banner_pattern.desc": "Schnauze",
  "item.minecraft.piglin_banner_pattern.new": "Schnauzn Bannervorlag",
  "item.minecraft.piglin_brute_spawn_egg": "Piglin-Barbar-Spawn-Oa",
  "item.minecraft.piglin_spawn_egg": "Piglin-Spawn-Oa",
  "item.minecraft.pillager_spawn_egg": "Plünderer-Spawn-Oa",
  "item.minecraft.pink_bundle": "Pinks Bündel",
  "item.minecraft.pink_dye": "Rosa Foabstoff",
  "item.minecraft.pink_harness": "Rosa Gschirr",
  "item.minecraft.pitcher_plant": "Kannenbleame",
  "item.minecraft.pitcher_pod": "Kannenbleamesamen",
  "item.minecraft.plenty_pottery_shard": "Reichtum-Töpferscherm",
  "item.minecraft.plenty_pottery_sherd": "Reichtum-Töpferscherm",
  "item.minecraft.poisonous_potato": "Giftige Kadoffe",
  "item.minecraft.polar_bear_spawn_egg": "Eisbär-Spawn-Oa",
  "item.minecraft.popped_chorus_fruit": "Springende Chorus-Frucht",
  "item.minecraft.porkchop": "Rohs Schweiners",
  "item.minecraft.potato": "Eadopfe",
  "item.minecraft.potion": "Trank",
  "item.minecraft.potion.effect.awkward": "Seltsamer Trank",
  "item.minecraft.potion.effect.empty": "Nicht braubara Trank",
  "item.minecraft.potion.effect.fire_resistance": "Trank da Feuerresistenz",
  "item.minecraft.potion.effect.harming": "Trank des Schadens",
  "item.minecraft.potion.effect.healing": "Trank da Heilung",
  "item.minecraft.potion.effect.infested": "Trank as Befalls",
  "item.minecraft.potion.effect.invisibility": "Trank da Unsichtbarkeit",
  "item.minecraft.potion.effect.leaping": "Trank da Sprungkraft",
  "item.minecraft.potion.effect.levitation": "Trank da Schwebekroft",
  "item.minecraft.potion.effect.luck": "Trank des Glücks",
  "item.minecraft.potion.effect.mundane": "Gewöhnlicher Trank",
  "item.minecraft.potion.effect.night_vision": "Trank da Nachtsicht",
  "item.minecraft.potion.effect.oozing": "Trank as Rotzns",
  "item.minecraft.potion.effect.poison": "Gifttrank",
  "item.minecraft.potion.effect.regeneration": "Trank da Regeneration",
  "item.minecraft.potion.effect.slow_falling": "Trank des sanftn Fois",
  "item.minecraft.potion.effect.slowness": "Trank da Langsamkeit",
  "item.minecraft.potion.effect.strength": "Trank da Stärke",
  "item.minecraft.potion.effect.swiftness": "Trank da Schnelligkeit",
  "item.minecraft.potion.effect.thick": "Dicker Trank",
  "item.minecraft.potion.effect.turtle_master": "Trank des Schuidkrötenmeistas",
  "item.minecraft.potion.effect.water": "Wossaflasche",
  "item.minecraft.potion.effect.water_breathing": "Trank da Unterwossaatmung",
  "item.minecraft.potion.effect.weakness": "Trank da Schwäche",
  "item.minecraft.potion.effect.weaving": "Trank da Spinnerei",
  "item.minecraft.potion.effect.wind_charged": "Trank as Liftals",
  "item.minecraft.pottery_shard_archer": "Schützen-Töpferscherm",
  "item.minecraft.pottery_shard_arms_up": "Gfuchtl-Töpferscherm",
  "item.minecraft.pottery_shard_prize": "Juweln-Töpferscherm",
  "item.minecraft.pottery_shard_skull": "Schädl-Töpferscherm",
  "item.minecraft.powder_snow_bucket": "Pulvaschnääoama",
  "item.minecraft.prismarine_crystals": "Prismarinkristalle",
  "item.minecraft.prismarine_shard": "Prismarinscherbe",
  "item.minecraft.prize_pottery_shard": "Juweln-Töpferscherm",
  "item.minecraft.prize_pottery_sherd": "Juweln-Töpferscherm",
  "item.minecraft.pufferfish": "Kuglfiisch",
  "item.minecraft.pufferfish_bucket": "Kuglfiischoima",
  "item.minecraft.pufferfish_spawn_egg": "Kuglfisch-Spawn-Oa",
  "item.minecraft.pumpkin_pie": "Kürbiskuacha",
  "item.minecraft.pumpkin_seeds": "Kürbiskerndl",
  "item.minecraft.purple_bundle": "Lilans Bündel",
  "item.minecraft.purple_dye": "Violetta Foabstoff",
  "item.minecraft.purple_harness": "Lila Gschirr",
  "item.minecraft.quartz": "Netherquarz",
  "item.minecraft.rabbit": "Rohs Haas",
  "item.minecraft.rabbit_foot": "Hasenfuaß",
  "item.minecraft.rabbit_hide": "Hasenfell",
  "item.minecraft.rabbit_spawn_egg": "Hasn-Spawn-Oa",
  "item.minecraft.rabbit_stew": "Haasnsuppn",
  "item.minecraft.raiser_armor_trim_smithing_template": "Schmiedevorlang",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Eitern-Rüstungsschmuck",
  "item.minecraft.ravager_spawn_egg": "Verwüsta-Spawn-Oa",
  "item.minecraft.raw_copper": "Rohkupfa",
  "item.minecraft.raw_gold": "Rohgoid",
  "item.minecraft.raw_iron": "Roheisen",
  "item.minecraft.recovery_compass": "Wiederherhoikompass",
  "item.minecraft.red_bundle": "Roads Bündel",
  "item.minecraft.red_dye": "Rouda Foabstoff",
  "item.minecraft.red_harness": "Roads Gschirr",
  "item.minecraft.redstone": "Redstone-Waugerln",
  "item.minecraft.resin_brick": "Harzziegl",
  "item.minecraft.resin_clump": "Harzklumpn",
  "item.minecraft.rib_armor_trim_smithing_template": "Schmiedevorlang",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rippal-Rüstungsschmuck",
  "item.minecraft.rotten_flesh": "Verrottetes Fleisch",
  "item.minecraft.saddle": "Sattel",
  "item.minecraft.salmon": "Rohs Lachs",
  "item.minecraft.salmon_bucket": "Kübe voi Lachs",
  "item.minecraft.salmon_spawn_egg": "Lachs-Spawn-Oa",
  "item.minecraft.scrape_pottery_sherd": "Kratzer-Töpferscherm",
  "item.minecraft.scute": "Schuppe",
  "item.minecraft.sentry_armor_trim_smithing_template": "Schmiedevorlang",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Praesidium-Rüstungsschmuck",
  "item.minecraft.shaper_armor_trim_smithing_template": "Schmiedevorlang",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Künstler-Rüstungsschmuck",
  "item.minecraft.sheaf_pottery_shard": "Garbn-Töpferscherm",
  "item.minecraft.sheaf_pottery_sherd": "Garbn-Töpferscherm",
  "item.minecraft.shears": "Rebschaa",
  "item.minecraft.sheep_spawn_egg": "Schof-Spawn-Oa",
  "item.minecraft.shelter_pottery_shard": "Bunker-Töpferscherm",
  "item.minecraft.shelter_pottery_sherd": "Bunker-Töpferscherm",
  "item.minecraft.shield": "Schuidl",
  "item.minecraft.shield.black": "Schwoazes Schuidl",
  "item.minecraft.shield.blue": "Blaues Schuidl",
  "item.minecraft.shield.brown": "Braunes Schuidl",
  "item.minecraft.shield.cyan": "Türkisa Schuidl",
  "item.minecraft.shield.gray": "Graua Schuidl",
  "item.minecraft.shield.green": "Greana Schuidl",
  "item.minecraft.shield.light_blue": "Höiblaues Schuidl",
  "item.minecraft.shield.light_gray": "Höigraua Schuidl",
  "item.minecraft.shield.lime": "Giftgreana Schuidl",
  "item.minecraft.shield.magenta": "Magenta Schuidl",
  "item.minecraft.shield.orange": "Orangschenes Schuidl",
  "item.minecraft.shield.pink": "Rosa Schuidl",
  "item.minecraft.shield.purple": "Violetta Schuidl",
  "item.minecraft.shield.red": "Roude Schuidl",
  "item.minecraft.shield.white": "Weißa Schuidl",
  "item.minecraft.shield.yellow": "Gelba Schuidl",
  "item.minecraft.shulker_shell": "Shulker-Schale",
  "item.minecraft.shulker_spawn_egg": "Shulker-Spawn-Oa",
  "item.minecraft.sign": "Schild",
  "item.minecraft.silence_armor_trim_smithing_template": "Schmiedevorlang",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Ruah-Rüstungsschmuck",
  "item.minecraft.silverfish_spawn_egg": "Silberfisch-Spawn-Oa",
  "item.minecraft.skeleton_horse_spawn_egg": "Skelettpferdl-Spawn-Oa",
  "item.minecraft.skeleton_spawn_egg": "Skelett-Spawn-Oa",
  "item.minecraft.skull_banner_pattern": "Bannervorlagn",
  "item.minecraft.skull_banner_pattern.desc": "Schädl",
  "item.minecraft.skull_banner_pattern.new": "Schäk-Bannervorlag",
  "item.minecraft.skull_pottery_shard": "Schädl-Töpferscherm",
  "item.minecraft.skull_pottery_sherd": "Schädl-Töpferscherm",
  "item.minecraft.slime_ball": "Schleimboi",
  "item.minecraft.slime_spawn_egg": "Schleim-Spawn-Oa",
  "item.minecraft.smithing_template": "Schmiedevorlang",
  "item.minecraft.smithing_template.applies_to": "Anwendbar af:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Metallbarren oda Kristall dazua doa",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Rüstung",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Rüstungsteil dazua doa",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Metallbarren & Kristalle",
  "item.minecraft.smithing_template.ingredients": "Zutatn:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Netheritebarren dazua doa",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamantausristung",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Diamantristung, - waffe oda - werkzeig dazua doa",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netheritebarren",
  "item.minecraft.smithing_template.upgrade": "Afwertn: ",
  "item.minecraft.sniffer_spawn_egg": "Schniffer Spawn-Ei",
  "item.minecraft.snort_pottery_shard": "Schnaufa-Töpferscherm",
  "item.minecraft.snort_pottery_sherd": "Schnaufa-Töpferscherm",
  "item.minecraft.snout_armor_trim_smithing_template": "Schmiedevorlang",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Schnauzn-Rüstungsschmuck",
  "item.minecraft.snow_golem_spawn_egg": "Schneegolem Spawn-Ei",
  "item.minecraft.snowball": "Schnääboi",
  "item.minecraft.spectral_arrow": "Spektralpfeil",
  "item.minecraft.spider_eye": "Spinnaaug",
  "item.minecraft.spider_spawn_egg": "Spinna-Spawn-Oa",
  "item.minecraft.spire_armor_trim_smithing_template": "Schmiedevorlang",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Turmspitzn-Rüstungsschmuck",
  "item.minecraft.splash_potion": "Artikel.minecraft.\nSpritztrank",
  "item.minecraft.splash_potion.effect.awkward": "Seltsama Wurftrank",
  "item.minecraft.splash_potion.effect.empty": "Nicht braubara Wurftrank",
  "item.minecraft.splash_potion.effect.fire_resistance": "Wurftrank da Feiaresistenz",
  "item.minecraft.splash_potion.effect.harming": "Wurftrank des Schadns",
  "item.minecraft.splash_potion.effect.healing": "Wurftrank da Heilung",
  "item.minecraft.splash_potion.effect.infested": "Wurftrank as Befalls",
  "item.minecraft.splash_potion.effect.invisibility": "Wurftrank da Unsichtbarkeit",
  "item.minecraft.splash_potion.effect.leaping": "Wurftrank da Sprungkroft",
  "item.minecraft.splash_potion.effect.levitation": "Wurftrank da Schwebekroft",
  "item.minecraft.splash_potion.effect.luck": "Wurftrank des Glücks",
  "item.minecraft.splash_potion.effect.mundane": "Gewöhnlicha Wurftrank",
  "item.minecraft.splash_potion.effect.night_vision": "Wurftrank da Nochtsicht",
  "item.minecraft.splash_potion.effect.oozing": "Wuafttank as Rotzns",
  "item.minecraft.splash_potion.effect.poison": "Wurftrank da Vergiftung",
  "item.minecraft.splash_potion.effect.regeneration": "Wurftrank da Regeneration",
  "item.minecraft.splash_potion.effect.slow_falling": "Wurftrank des sanftn Fois",
  "item.minecraft.splash_potion.effect.slowness": "Wurftrank da Langsamkeit",
  "item.minecraft.splash_potion.effect.strength": "Wurftrank da Stärke",
  "item.minecraft.splash_potion.effect.swiftness": "Wurftrank da Schneiigkeit",
  "item.minecraft.splash_potion.effect.thick": "Dickflüssiga Wurftrank",
  "item.minecraft.splash_potion.effect.turtle_master": "Wurftrank des Schuidkrötenmeistas",
  "item.minecraft.splash_potion.effect.water": "Werfbare Wossaflasche",
  "item.minecraft.splash_potion.effect.water_breathing": "Wurftrank da Untawossaatmung",
  "item.minecraft.splash_potion.effect.weakness": "Wurftrank da Schwäche",
  "item.minecraft.splash_potion.effect.weaving": "Wuaftrank da Spinnerei",
  "item.minecraft.splash_potion.effect.wind_charged": "Wuaftrank as Liftl",
  "item.minecraft.spruce_boat": "Fichtnhoizboot",
  "item.minecraft.spruce_chest_boat": "Fichtnhoiztruhenboot",
  "item.minecraft.spyglass": "Feanroa",
  "item.minecraft.squid_spawn_egg": "Tintnfisch-Spawn-Oa",
  "item.minecraft.stick": "Stock",
  "item.minecraft.stone_axe": "Stoahogg",
  "item.minecraft.stone_hoe": "Stoahau",
  "item.minecraft.stone_pickaxe": "Stoagrompm",
  "item.minecraft.stone_shovel": "Stoaschaufl",
  "item.minecraft.stone_spear": "Stoaspiaß",
  "item.minecraft.stone_sword": "Stoaschwert",
  "item.minecraft.stray_spawn_egg": "Eiswondera-Spawn-Oa",
  "item.minecraft.strider_spawn_egg": "Schreita-Spawn-Oa",
  "item.minecraft.string": "Fadn",
  "item.minecraft.sugar": "Zugga",
  "item.minecraft.suspicious_stew": "Komische Suppn",
  "item.minecraft.sweet_berries": "Siaßbean",
  "item.minecraft.tadpole_bucket": "Empa foi mit Kaulquappm",
  "item.minecraft.tadpole_spawn_egg": "Kaulquappm-Spawn-Oa",
  "item.minecraft.tide_armor_trim_smithing_template": "Schmiedevorlang",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Bobs-Rüstungsschmuck",
  "item.minecraft.tipped_arrow": "Getränkter Pfeil",
  "item.minecraft.tipped_arrow.effect.awkward": "Tränkter Pfeil",
  "item.minecraft.tipped_arrow.effect.empty": "Nicht herstellbara getränkta Pfeil",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Feierresistenzpfeil",
  "item.minecraft.tipped_arrow.effect.harming": "Schadenspfeil",
  "item.minecraft.tipped_arrow.effect.healing": "Heilpfeil",
  "item.minecraft.tipped_arrow.effect.infested": "Pfeil as Befalls",
  "item.minecraft.tipped_arrow.effect.invisibility": "Unsichtbarkeitspfeil",
  "item.minecraft.tipped_arrow.effect.leaping": "Sprungkraftpfeil",
  "item.minecraft.tipped_arrow.effect.levitation": "Schwebpfeil",
  "item.minecraft.tipped_arrow.effect.luck": "Glückspfeil",
  "item.minecraft.tipped_arrow.effect.mundane": "Tränkter Pfeil",
  "item.minecraft.tipped_arrow.effect.night_vision": "Nachtsichtpfeil",
  "item.minecraft.tipped_arrow.effect.oozing": "Pfeil as Rotzns",
  "item.minecraft.tipped_arrow.effect.poison": "Giftpfeil",
  "item.minecraft.tipped_arrow.effect.regeneration": "Regenerationspfeil",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Pfeil des sanften Falls",
  "item.minecraft.tipped_arrow.effect.slowness": "Langsamkeitspfeil",
  "item.minecraft.tipped_arrow.effect.strength": "Stärkepfeil",
  "item.minecraft.tipped_arrow.effect.swiftness": "Schnelligkeitspfeil",
  "item.minecraft.tipped_arrow.effect.thick": "Tränkter Pfeil",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Pfeil des Schildkrötenmeisters",
  "item.minecraft.tipped_arrow.effect.water": "Nasser Pfeil",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Wossaatmungspfeil",
  "item.minecraft.tipped_arrow.effect.weakness": "Schwächepfeil",
  "item.minecraft.tipped_arrow.effect.weaving": "Pfeil da Spinnerei",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Pfeil as Liftals",
  "item.minecraft.tnt_minecart": "TNT-Lore",
  "item.minecraft.torchflower_seeds": "Fackelbleamesamen",
  "item.minecraft.totem_of_undying": "Totem da Unsterblichkeit",
  "item.minecraft.trader_llama_spawn_egg": "Händlalama-Spawn-Oa",
  "item.minecraft.trial_key": "Priafungsschlissl",
  "item.minecraft.trident": "Dreizack",
  "item.minecraft.tropical_fish": "Tropnfiisch",
  "item.minecraft.tropical_fish_bucket": "Tropnfiischoima",
  "item.minecraft.tropical_fish_spawn_egg": "Tropischa Fiisch-Spawn-Oa",
  "item.minecraft.turtle_helmet": "Schuidkrötnpanza",
  "item.minecraft.turtle_scute": "Schildkrötnschuppn",
  "item.minecraft.turtle_spawn_egg": "Schuidkrötn-Spawn-Oa",
  "item.minecraft.vex_armor_trim_smithing_template": "Schmiedevorlang",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Krebs-Rüstungsschmuck",
  "item.minecraft.vex_spawn_egg": "Poitergeist-Spawn-Oa",
  "item.minecraft.villager_spawn_egg": "Dorfbewohna-Spawn-Oa",
  "item.minecraft.vindicator_spawn_egg": "Maulaff-Spawn-Oa",
  "item.minecraft.wandering_trader_spawn_egg": "Dandler-Spawn-Oa",
  "item.minecraft.ward_armor_trim_smithing_template": "Schmiedevorlang",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Befestigungs-Rüstungsschmuck",
  "item.minecraft.warden_spawn_egg": "Wärta-Spawn-Oa",
  "item.minecraft.warped_fungus_on_a_stick": "Wirrschwammalrute",
  "item.minecraft.water_bucket": "Wossaoima",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Schmiedevorlang",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Pfadfinder-Rüstungsschmuck",
  "item.minecraft.wheat": "Woazn",
  "item.minecraft.wheat_seeds": "Woaznkerndl",
  "item.minecraft.white_bundle": "Weißs Bündel",
  "item.minecraft.white_dye": "Weißa Foabstoff",
  "item.minecraft.white_harness": "Weißs Gschirr",
  "item.minecraft.wild_armor_trim_smithing_template": "Schmiedevorlang",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wuidnis-Rüstungsschmuck",
  "item.minecraft.wind_charge": "Windkugl",
  "item.minecraft.witch_spawn_egg": "Hexn-Spawn-Oa",
  "item.minecraft.wither_skeleton_spawn_egg": "Witherskelett-Spawn-Oa",
  "item.minecraft.wither_spawn_egg": "Wither-Spawn-Oa",
  "item.minecraft.wolf_armor": "Hundsrüstung",
  "item.minecraft.wolf_spawn_egg": "Woifs-Spawn-Oa",
  "item.minecraft.wooden_axe": "Hoizhogg",
  "item.minecraft.wooden_hoe": "Hoizhau",
  "item.minecraft.wooden_pickaxe": "Hoizgrompm",
  "item.minecraft.wooden_shovel": "Hoizschaufl",
  "item.minecraft.wooden_spear": "Hoizspiaß",
  "item.minecraft.wooden_sword": "Hoizschwert",
  "item.minecraft.writable_book": "Buach und Feda",
  "item.minecraft.written_book": "Voigschrims Buach",
  "item.minecraft.yellow_bundle": "Geibs Bündel",
  "item.minecraft.yellow_dye": "Gejba Foabstoff",
  "item.minecraft.yellow_harness": "Geibs Gschirr",
  "item.minecraft.zoglin_spawn_egg": "Zoglin-Spawn-Oa",
  "item.minecraft.zombie_horse_spawn_egg": "Zombiepferdl-Spawn-Oa",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombienautilus-Spawn-Oa",
  "item.minecraft.zombie_spawn_egg": "Zombie-Spawn-Oa",
  "item.minecraft.zombie_villager_spawn_egg": "Zombiedorfmensch-Spawn-Oa",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombifizierter-Piglin-Spawn-Oa"
}
export const bar = items; 
